<template>
    <div class="timers" :class="[$mq]" v-if="show_timers">
        <TimerProductKpiCards />

        <Topbar :categories="categories" @selectCategory="selectCategory" @addTimer="show_timers = false" @showOptions="openModalChangeView()"></Topbar>

        <div id="board">
            <Column v-for="column in columns" :countColumns="columns.length" :visibilityType="currentVisibility" :showImages="showProductImages" :key="column.id" :data="column" :timers="columnTimers[column.id] ? columnTimers[column.id] : []" @clickTimer="showPopupOptionsTimer" @longPress="showAlertLongTimer" :clickEnabledMulti="clickEnabledMulti" @addTimerSelected="addTimerSelected" @selectAllTimers="handleSelectAllTimers" @deleteSelectAll="handleDeleteSelectAll"></Column>
        </div>

        <TimerProductRecommendation
            :busy="isDeletingExpiredRecommendation"
            :product-name="recommendedAddProductName"
            :suggested-products="recommendedAddProducts"
            @dismiss="dismissRecommendation"
            @primary="handleRecommendationPrimary"
            @remove-only="handleRecommendationRemoveOnly"
            @remove-and-add="handleRecommendationRemoveAndAdd"
        />

        <CustomModal
            v-if="isPopupOpen"
            container-class="popup-change-view"
            modal-class="popup-change-view__panel"
            :title="$t('label.popup.change_view')"
            @close="closePopup"
        >
            <div class="change-view-modal" :class="{ portrait: isApp || ['portrait'].includes($mq) }">
                <section class="change-view-modal__section">
                    <h3 class="change-view-modal__section-title">{{ $t('timersproduct.visibility.show_products_by') }}</h3>
                    <div class="change-view-modal__options">
                        <button
                            v-for="option in popupOptions"
                            :key="'visibility-' + option.value"
                            type="button"
                            class="change-view-modal__option"
                            :class="{ selected: currentVisibility === option.value }"
                            @click="changeVisibility(option.value)"
                        >
                            <span class="change-view-modal__radio" :class="{ 'is-checked': currentVisibility === option.value }" aria-hidden="true"></span>
                            <span class="change-view-modal__option-label">{{ option.displayText }}</span>
                        </button>
                    </div>
                </section>

                <section class="change-view-modal__section">
                    <h3 class="change-view-modal__section-title">{{ $t('timersproduct.visibility.product_image') }}</h3>
                    <div class="change-view-modal__options">
                        <button
                            v-for="option in imageVisibilityOptions"
                            :key="'images-' + String(option.value)"
                            type="button"
                            class="change-view-modal__option"
                            :class="{ selected: showProductImages === option.value }"
                            @click="changeImageVisibility(option.value)"
                        >
                            <span class="change-view-modal__radio" :class="{ 'is-checked': showProductImages === option.value }" aria-hidden="true"></span>
                            <span class="change-view-modal__option-label">{{ option.displayText }}</span>
                        </button>
                    </div>
                </section>

                <div class="change-view-modal__actions">
                    <Button bType="cancel" customClass="selector-popup" :bLabel="'timersproduct.visibility.cancel'" :bCallback="closePopup" />
                    <button type="button" class="change-view-modal__apply-btn" @click="changeVisibilityEnd">
                        {{ $t('timersproduct.visibility.apply') }}
                    </button>
                </div>
            </div>
        </CustomModal>

        <CustomModal id="popup-to-print-timer" v-if="isPopupToPrintTimerOpen" :title="getTimers[newTimerToPrint] && getTimers[newTimerToPrint].data ? getTimers[newTimerToPrint].data.product : ''" @close="closePopupToPrintTimer">
            <div class="list" :class="{ portrait: isApp || ['portrait'].includes($mq) }">
                <div>
                    <p class="title" v-html="$t('timersproduct.popup.print_timer.title', { product: getTimers[newTimerToPrint] && getTimers[newTimerToPrint].data ? getTimers[newTimerToPrint].data.product : '' })"></p>
                    <p class="message" v-html="$t('timersproduct.popup.print_timer.message')"></p>
                </div>
                <div class="action-buttons">
                    <Button bType="cancel" customClass="selector-popup" :bLabel="$t('timersproduct.popup.print_timer.cancel')" :bCallback="closePopupToPrintTimer" />
                    <Button bType="confirm" :ref="'buttonConfirmToPrintTimer'" :bLabel="$t('timersproduct.popup.print_timer.confirm')" customClass="selector-popup" :bCallback="confirmPrintTimer" />
                </div>
            </div>
        </CustomModal>

        <CustomModal v-if="popupTimerOpen" :title="getTimers[keyTimer] && getTimers[keyTimer].data ? getTimers[keyTimer].data.product : ''" @close="closePopupTimer">
            <!-- Contenido dinámico como slot -->
            <div class="parent-container">
                <div class="start-units" v-if="verifyQuantityInitialLabel()">
                    <div class="icon-units"></div>
                    <span class="number-units">{{ previewTimer.quantity }}</span>
                    <span class="text-units"> {{ $t('timersproduct.units_starts') }} </span>
                </div>
            </div>

            <div class="preview">
                <div class="zpl-preview-wrapper">
                    <Preview
                      v-if="!isZplPreview"
                      :refresh="false"
                      :key="keyTimer"
                      :calculate="n"
                      :data="previewTimer"
                    />

                    <ZplPreview
                      v-else
                      :data="zpl"
                      :density="density"
                      :width="labelWidth"
                      :height="labelHeight"
                      :values="zplValues"
                      :params="zplParams"
                      :showControls="false"
                      :fitToContainer="true"
                      :previewScale="2"
                      :scale="1"
                      :key="zplKey"
                    />
                </div>
                <div class="quantity">
                    <span v-if="showUnitsQuantityInPopup">
                        {{ $t('timersproduct.units_avaible') }}: <span class="units">{{ previewTimer.quantity_avaibles }}</span>
                    </span>
                </div>
            </div>

            <div class="list" :class="{ portrait: isApp || ['portrait'].includes($mq) }">
                <div v-if="previousMoveTimer" class="button-with-controls" v-for="moveBackState in [previousMoveTimer]" :key="moveBackState.id">
                    <div
                        v-if="verifyQuantityInitial()"
                        class="control-button minus-button"
                        :class="{
                            'minus-blue-active': canDecreaseMoveBack,
                            'minus-blue-inactive': !canDecreaseMoveBack
                        }"
                        @click="decreaseMoveQuantity('movedBackTimerCount')"
                        tabindex="0"
                        role="button"
                        :aria-disabled="!canDecreaseMoveBack"
                    ></div>
                    <Button bType="move" :bLabel="verifyQuantityInitial() ? $t('label.popup.move_timer_count', { c: movedBackTimerCount, s: moveBackState.name }) : $t('label.popup.move_timer', { s: moveBackState.name })" :customClass="['selector-popup', !canMoveBackTimer ? 'blocked' : '']" :bCallback="moveTimerNextState" :bCallbackProps="{ timer_id: keyTimer, next_state: moveBackState.id }" :style="{ width: verifyQuantityInitial() ? '80%' : '100%' }" />
                    <div
                        v-if="verifyQuantityInitial()"
                        class="control-button plus-button"
                        :class="{
                            'plus-blue-active': canIncreaseMoveBack,
                            'plus-blue-inactive': !canIncreaseMoveBack
                        }"
                        @click="increaseMoveQuantity('movedBackTimerCount')"
                        tabindex="0"
                        role="button"
                        :aria-disabled="!canIncreaseMoveBack"
                    ></div>
                </div>

                <div class="button-with-controls" v-if="showMoveTimer" v-for="(moveState, index) in nextMoveTimer" :key="moveState.id">
                    <div
                        v-if="verifyQuantityInitial()"
                        class="control-button minus-button"
                        :class="{
                            'minus-blue-active': index === 0 ? canDecreaseMove1 : canDecreaseMove2,
                            'minus-blue-inactive': index === 0 ? !canDecreaseMove1 : !canDecreaseMove2
                        }"
                        @click="decreaseMoveQuantity('movedTimerCount' + (index + 1))"
                        tabindex="0"
                        role="button"
                        :aria-disabled="index === 0 ? !canDecreaseMove1 : !canDecreaseMove2"
                    ></div>

                    <Button bType="move" :bLabel="verifyQuantityInitial() ? $t('label.popup.move_timer_count', { c: index === 0 ? movedTimerCount1 : movedTimerCount2, s: moveState.name }) : $t('label.popup.move_timer', { s: moveState.name })" :customClass="['selector-popup', !canMoveTimer ? 'blocked' : '']" :bCallback="moveTimerNextState" :bCallbackProps="{ timer_id: keyTimer, next_state: moveState.id, index: index }" :style="{ width: verifyQuantityInitial() ? '80%' : '100%' }" />

                    <div
                        v-if="verifyQuantityInitial()"
                        class="control-button plus-button"
                        :class="{
                            'plus-blue-active': index === 0 ? canIncreaseMove1 || canMoveTimer : canIncreaseMove2 || canMoveTimer,
                            'plus-blue-inactive': index === 0 ? !canIncreaseMove1 || !canMoveTimer : !canIncreaseMove2 || !canMoveTimer
                        }"
                        @click="increaseMoveQuantity('movedTimerCount' + (index + 1))"
                        tabindex="0"
                        role="button"
                        :aria-disabled="index === 0 ? !canIncreaseMove1 : !canIncreaseMove2"
                    ></div>
                </div>

                <div v-if="statusPrinter && canPrintTimer" class="button-with-controls">
                    <div
                        v-if="verifyQuantityInitial()"
                        class="control-button minus-button"
                        :class="{
                            'minus-gray-active': canDecreasePrint,
                            'minus-gray-inactive': !canDecreasePrint
                        }"
                        @click="decreaseMoveQuantity('printedTimerCount')"
                        tabindex="0"
                        role="button"
                        :aria-disabled="!canDecreasePrint"
                    ></div>

                    <Button bType="print" :bLabel="verifyQuantityInitial() ? $t('timersproduct.renew_printer_count', { c: printedTimerCount }) : $t('timersproduct.renew_printer')" customClass="selector-popup" :bCallback="requestTimerPrintConfirm" :bCallbackProps="keyTimer" :style="{ width: verifyQuantityInitial() ? '80%' : '100%' }" />

                    <div
                        v-if="verifyQuantityInitial()"
                        class="control-button plus-button"
                        :class="{
                            'plus-gray-active': canIncreasePrint,
                            'plus-gray-inactive': !canIncreasePrint
                        }"
                        @click="increaseMoveQuantity('printedTimerCount')"
                        tabindex="0"
                        role="button"
                        :aria-disabled="!canIncreasePrint"
                    ></div>
                </div>

                <div v-if="canAddUnitsForSelectedTimer" class="button-with-controls">
                    <div
                        class="control-button minus-button"
                        :class="{
                            'minus-gray-active': canDecreaseAddUnits,
                            'minus-gray-inactive': !canDecreaseAddUnits
                        }"
                        @click="decreaseMoveQuantity('addUnitsCount')"
                        tabindex="0"
                        role="button"
                        :aria-disabled="!canDecreaseAddUnits"
                    ></div>
                    <Button bType="add-units" :bLabel="addUnitsCount === 1 ? $t('timersproduct.add_units_button_unique') : $t('timersproduct.add_units_button', { c: addUnitsCount })" customClass="selector-popup" :bCallback="addUnitsToTimer" :style="{ width: '80%' }">
                        <template #icon>
                            <i class="i-andy-add i-andy-m btn-add-units__icon" aria-hidden="true"></i>
                        </template>
                    </Button>
                    <div
                        class="control-button plus-button"
                        :class="{
                            'plus-gray-active': canIncreaseAddUnits,
                            'plus-gray-inactive': !canIncreaseAddUnits
                        }"
                        @click="increaseMoveQuantity('addUnitsCount')"
                        tabindex="0"
                        role="button"
                        :aria-disabled="!canIncreaseAddUnits"
                    ></div>
                </div>

                <div class="button-with-controls">
                    <div
                        v-if="verifyDeleteQuantityControlsEnabled()"
                        class="control-button minus-button"
                        :class="{
                            'minus-red-active': canDecreaseDelete,
                            'minus-red-inactive': !canDecreaseDelete
                        }"
                        @click="decreaseMoveQuantity('deletedTimerCount')"
                        tabindex="0"
                        role="button"
                        :aria-disabled="!canDecreaseDelete"
                    ></div>

                    <Button bType="delete-timer" :bLabel="verifyDeleteQuantityControlsEnabled() ? $t('label.popup.delete_timer_count', { c: deletedTimerCount }) : $t('label.popup.delete_timer')" customClass="selector-popup" :bCallback="deleteTimer" :bCallbackProps="keyTimer" :style="{ width: verifyDeleteQuantityControlsEnabled() ? '80%' : '100%' }" />

                    <div
                        v-if="verifyDeleteQuantityControlsEnabled()"
                        class="control-button plus-button"
                        :class="{
                            'plus-red-active': canIncreaseDelete,
                            'plus-red-inactive': !canIncreaseDelete
                        }"
                        @click="increaseMoveQuantity('deletedTimerCount')"
                        tabindex="0"
                        role="button"
                        :aria-disabled="!canIncreaseDelete"
                    ></div>
                </div>
            </div>
        </CustomModal>

        <!-- Modal de Grupo de Timers -->
        <TimerGroupModal
          v-if="popupGroupTimerOpen"
          :key="`group-modal-${groupTimers.map((t) => t.id).sort().join('-')}`"
          :title="selectedGroupTimer && selectedGroupTimer.data ? selectedGroupTimer.data.product : $t('timersproduct.group.timers_in_group')"
          :groupTimers="groupTimers"
          :initialSelectedTimer="selectedGroupTimer"
          :previewData="groupPreviewTimer"
          :isZplPreview="groupIsZplPreview"
          :zpl="groupZpl"
          :density="groupDensity"
          :labelWidth="groupLabelWidth"
          :labelHeight="groupLabelHeight"
          :zplValues="groupZplValues"
          :zplParams="groupZplParams"
          :zplKey="groupZplKey"
          :canMoveTimer="groupCanMoveTimer"
          :canMoveBackTimer="groupCanMoveBackTimer"
          :canPrintTimer="groupCanPrintTimer"
          :previousMoveState="groupPreviousMoveState"
          :nextMoveStates="groupNextMoveStates"
          @close="closePopupGroupTimer"
          @timerSelected="handleGroupTimerSelected"
          @moveTimer="handleGroupMoveTimer"
          @printTimer="handleGroupPrintTimer"
          @deleteTimer="handleGroupDeleteTimer"
          @addUnits="handleGroupAddUnits"
        />
    </div>
    <Products
        v-else
        :show-images="showProductImages"
        :recommended-product-ids="pendingRecommendedProductIds"
        :on-recommendation-add-result="recommendationAddResultHandler"
        @timerCreated="timerCreated"
        @closeProducts="handleCloseProducts"
        @createTimerInit="createTimerInit"
        @createTimerEnd="createTimerEnd"
        @recommended-consumed="clearPendingRecommendedProductIds"
    ></Products>
</template>

<script>
import { formatPrintedDateFromStore } from '@/utils/dateFormatters'
import Column from '@/components/domain/timerproduct/column.vue'
import Topbar from '@/components/domain/timerproduct/topbar.vue'
import Products from '@/components/domain/timerproduct/products.vue'
import TimerProductKpiCards from '@/components/domain/timerproduct/TimerProductKpiCards.vue'
import TimerProductRecommendation from '@/components/domain/timerproduct/TimerProductRecommendation.vue'
import CustomModal from '@/components/domain/timerproduct/modal.vue'
import TimerGroupModal from '@/components/domain/timerproduct/TimerGroupModal.vue'
import Button from '@/components/domain/ui/Button.vue'
import Preview from '@/components/domain/label/preview.vue'
import ZplPreview from '@/components/domain/label/ZplPreview.vue'
import { RECOMMENDATION_VARIANT, TIMERPRODUCT_STATUS, TIMER_TICK_FAST_MS, TIMER_TICK_SLOW_MS } from '@/constants'
import i18n from '@/i18n'
import { gprinterStatusText } from '@/utils/gprinter/statusError'

function timerPrintError(error, productName) {
    const specific = gprinterStatusText(error, function (key, params) {
        return i18n.t(key, params)
    })
    if (specific) {
        return specific
    }
    const fallback = error && !error.status && error.msg ? i18n.t(error.msg) : i18n.tc('config.printer.error_print', 1)
    return fallback.replace('[product]', productName)
}
import { EventBus } from '@/eventBus.js'
import { referenceCanMovePast } from '@/utils/referenceCanMovePast.js'
import { buildCaducidadSnapshotsForParentFromChild } from '@/utils/caducidadSnapshotsForParentFromChild.js'
import {
    buildChannelMergeDateFields,
    getTimerDateFieldsForPayload,
    shouldPreserveTimerDatesOnMove
} from '@/utils/timerProductChannelMove.js'
import {
    computeNewParentQuantity,
    computeQuantityMove,
    computeRemainingUnits,
    findParentTimerByRelId,
    findParentTimerByRelations,
    mergeTimersRelations,
    shouldDeleteSourceAfterMove,
    timerProductStateBaseId as timerProductStateBaseIdUtil
} from '@/utils/timerProductMove.js'
import {
    buildZplPreviewState,
    createPrinterStoreAccessors,
    extractZPLFromPrinter as extractZPLFromPrinterUtil,
    isValidZPL as isValidZplString,
    resolveFormatForPrinterVariant as resolveFormatForPrintUtil
} from '@/utils/zplPreviewHelpers.js'

export default {
    components: { Column, Topbar, Products, TimerProductKpiCards, TimerProductRecommendation, Button, Preview, ZplPreview, CustomModal, TimerGroupModal },
    name: 'TimerProduct',
    data() {
        return {
            timers: [],
            selectedCategory: false,
            show_timers: true,
            isPopupOpen: false,
            isPopupToPrintTimerOpen: false,
            newTimerToPrint: false,
            numSecondsToPrintTimer: 5,
            intervalToPrintTimer: null,
            currentVisibility: 1,
            currentVisibilityBefore: 1,
            /**
             * BUILD-7551: preferencia visual de imágenes en tarjetas del board.
             * true = mostrar; false = ocultar (más timers visibles).
             */
            showProductImages: true,
            showProductImagesBefore: true,
            popupOptions: [
                {
                    displayText: this.$t('timersproduct.visibility.remaining_time'),
                    value: 1
                },
                {
                    displayText: this.$t('timersproduct.visibility.useful_life'),
                    value: 2
                }
            ],
            imageVisibilityOptions: [
                {
                    displayText: this.$t('timersproduct.visibility.show_all_images'),
                    value: true
                },
                {
                    displayText: this.$t('timersproduct.visibility.hide_all_images'),
                    value: false
                }
            ],
            popupTimerOpen: false,
            previewTimer: {},
            isZplPreview: false,
            zpl: '',
            density: 203,
            labelWidth: 55,
            labelHeight: 50,
            zplValues: {},
            zplParams: {},
            zplKey: 0,
            keyTimer: 0,
            n: 0,
            printerConfigured: false,
            showMoveTimer: false,
            canMoveTimer: false,
            canMoveBackTimer: false,
            canPrintTimer: true,
            nextMoveTimer: false,
            previousMoveTimer: false,
            clickEnabledMulti: false,
            lastTimerId: null,
            lastCallTime: 0,
            isTimersRestore: false,
            isDeletingExpiredRecommendation: false,
            /**
             * BUILD-7493: ids de producto a precargar en el wizard al salir del board.
             */
            pendingRecommendedProductIds: [],
            /**
             * BUILD-7492: contexto de “eliminar + añadir” mientras el wizard está abierto.
             * El borrado de expirados corre en segundo plano.
             */
            pendingCombinedRecommendation: null,
            deletedTimerCount: 1,
            movedTimerCount1: 1,
            movedTimerCount2: 1,
            printedTimerCount: 1,
            movedBackTimerCount: 1,
            canMovedTimer: true,
            addUnitsCount: 1,
            // Timer Group Modal
            popupGroupTimerOpen: false,
            groupTimers: [],
            selectedGroupTimer: null,
            groupPreviewTimer: {},
            groupIsZplPreview: false,
            groupZpl: '',
            groupDensity: 203,
            groupLabelWidth: 55,
            groupLabelHeight: 50,
            groupZplValues: {},
            groupZplParams: {},
            groupZplKey: 0,
            groupCanMoveTimer: false,
            groupCanMoveBackTimer: false,
            groupCanPrintTimer: false,
            groupPreviousMoveState: null,
            groupNextMoveStates: [],
            savedGroupCharacteristics: null,
            showUnitsQuantityInPopup: true,
            /** true si el confirm de imprimir se abrió tras mover de columna (afecta copias en printLabel) */
            pendingPrintIsAfterMove: false,
            /** IDs pendientes cuando el confirm agrupa varias impresiones (p. ej. modal de grupo) */
            pendingBatchPrintTimerIds: null,
            /** Evita doble clic en Confirmar durante impresión por lotes (antes caía al path individual y repetía el primero). */
            batchPrintConfirmInFlight: false,
            /** Durante movimiento múltiple desde modal de grupo: acumular IDs para un solo confirm al final (evita sobrescribir newTimerToPrint). */
            groupMoveCollectingPrintConfirmIds: false,
            pendingGroupMovePrintTimerIds: []
        }
    },
    computed: {
        activeKpiFilter() {
            return this.$store.getters['timerproduct/getActiveKpiFilter']
        },
        columns() {
            return this.$store.getters['timerproduct/getStates']
        },
        categories() {
            return this.$store.getters['timerproduct/getCategories']
        },
        columnTimers: function () {
            return this.$store.getters['timerproduct/getTimersGroupedByCategory'](this.selectedCategory)
        },
        isApp() {
            return this.$store.getters.getIsApp
        },
        statusPrinter() {
            return this.$store.getters['printer/getStatusPrinter']
        },
        errorPrinter() {
            return this.$store.getters['printer/getStatusErrorPrinter']
        },
        getTimeOutTimer() {
            const config = this.$store.getters['login/getConfig']
            const raw = config.timer_product_time_out
            if (raw === 0 || raw === '0') {
                return 0
            }
            if (raw === null || raw === undefined || raw === '') {
                return 5
            }
            const n = Number(raw)
            return Number.isFinite(n) && n > 0 ? n : 5
        },
        getTimers() {
            return this.$store.getters['timerproduct/getTimers']
        },
        /**
         * Unidades disponibles para mover / imprimir / borrar por lotes (prioriza quantity_avaibles; corrige typo quantity_avaible).
         */
        previewUnitsAvailable() {
            let raw = this.previewTimer.quantity_avaibles
            if (raw === undefined || raw === null || raw === '') {
                raw = this.previewTimer.quantity_avaible
            }
            if (raw === undefined || raw === null || raw === '') {
                raw = this.previewTimer.quantity
            }
            const n = parseInt(raw, 10)
            return !isNaN(n) && n >= 1 ? n : 1
        },
        canDecreaseMoveBack() {
            return !(this.movedBackTimerCount === 1)
        },
        canIncreaseMoveBack() {
            return this.movedBackTimerCount < this.previewUnitsAvailable
        },
        canDecreaseMove1() {
            return !(this.movedTimerCount1 === 1)
        },
        canIncreaseMove1() {
            return this.movedTimerCount1 < this.previewUnitsAvailable
        },
        canDecreaseMove2() {
            return !(this.movedTimerCount2 === 1)
        },
        canIncreaseMove2() {
            return this.movedTimerCount2 < this.previewUnitsAvailable
        },
        canDecreasePrint() {
            return !(this.printedTimerCount === 1)
        },
        canIncreasePrint() {
            return this.printedTimerCount < this.previewUnitsAvailable
        },
        canDecreaseDelete() {
            return !(this.deletedTimerCount === 1)
        },
        canIncreaseDelete() {
            return this.deletedTimerCount < this.previewUnitsAvailable
        },
        canAddUnitsForSelectedTimer() {
            const timer = this.getTimers[this.keyTimer]
            if (!timer || !timer.data) {
                return false
            }
            if (!this.isTimerLive(timer)) {
                return false
            }
            return this.timerReferenceAllowsAddUnits(timer)
        },
        canDecreaseAddUnits() {
            return this.addUnitsCount > 1
        },
        canIncreaseAddUnits() {
            return this.addUnitsCount < 99
        },
        recommendedAddProducts() {
            return this.$store.getters['timerproduct/getRecommendedAddProducts'] || []
        },
        recommendedAddProductName() {
            const products = this.recommendedAddProducts
            if (products.length !== 1 || !products[0] || !products[0].name) {
                return ''
            }

            return products[0].name
        },
        /**
         * Callback estable hacia Products: sobrevive al unmount del listado.
         */
        recommendationAddResultHandler() {
            return this.pendingCombinedRecommendation ? this.handleRecommendedAddResult : null
        }
    },
    methods: {
        /**
         * “Ahora no”: oculta la recomendación hasta reentrar al board.
         */
        dismissRecommendation() {
            this.$store.commit('timerproduct/setRecommendationDismissed', true)
        },
        /**
         * Recalcula visibilidad al entrar / volver a la pantalla principal.
         */
        resetRecommendationVisit() {
            this.$store.commit('timerproduct/setRecommendationDismissed', false)
        },
        /**
         * BUILD-7491 / BUILD-7493: acción primaria de la tarjeta.
         * La combinada abre el modal de revisión (BUILD-7492).
         *
         * @param {string} variant
         * @returns {Promise<void>}
         */
        async handleRecommendationPrimary(variant) {
            if (variant === RECOMMENDATION_VARIANT.DELETE_EXPIRED) {
                await this.deleteExpiredRecommendationTimers()
                return
            }

            if (variant === RECOMMENDATION_VARIANT.ADD_PRODUCTS) {
                this.startAddProductsRecommendation()
            }
        },
        /**
         * BUILD-7492: “Eliminar únicamente” reutiliza el flujo de BUILD-7491.
         *
         * @returns {Promise<void>}
         */
        handleRecommendationRemoveOnly() {
            return this.deleteExpiredRecommendationTimers()
        },
        /**
         * BUILD-7492: borra expirados en segundo plano y abre el wizard
         * (1 producto = ficha actual; varios = colección temporal).
         */
        handleRecommendationRemoveAndAdd() {
            const products = this.recommendedAddProducts.slice()
            if (!products.length) {
                return this.deleteExpiredRecommendationTimers()
            }

            const widgetData = this.$store.getters['timerproduct/getHomeWidgetData'] || {}
            const expiredCount = Number(widgetData.to_delete) || 0
            this.startCombinedRecommendation(expiredCount)
            this.startAddProductsRecommendation(products)
        },
        /**
         * Arranca el borrado de expirados sin overlay: el usuario ya está
         * en el wizard. El snackbar se decide al volver o al crear timers.
         *
         * @param {number} expiredCount
         */
        startCombinedRecommendation(expiredCount) {
            const pending = {
                expiredCount,
                addResult: null,
                deleteSettled: false,
                finalizing: false
            }

            pending.deletePromise = this.$store.dispatch('timerproduct/deleteExpiredTimers')
                .then((deleted) => {
                    pending.deleteSettled = true
                    return deleted
                })
                .catch((error) => {
                    pending.deleteSettled = true
                    logError('Error al eliminar productos expirados desde la recomendación combinada:', error)
                    return false
                })

            this.pendingCombinedRecommendation = pending
        },
        /**
         * Resultado del wizard cuando venimos de la combinada.
         * El callback se pasa por prop para sobrevivir al unmount de Products.
         *
         * @param {{ created?: number, failed?: number }|null|undefined} result
         */
        handleRecommendedAddResult(result) {
            if (!this.pendingCombinedRecommendation) {
                return
            }

            this.pendingCombinedRecommendation.addResult = {
                created: Number(result && result.created) || 0,
                failed: Number(result && result.failed) || 0
            }
            this.finalizeCombinedRecommendation()
        },
        handleCloseProducts() {
            this.show_timers = true
            this.finalizeCombinedRecommendation()
        },
        /**
         * Cierra el contexto combinado: espera el borrado en segundo plano
         * y muestra el snackbar (combinado, solo expirados, o error).
         *
         * @returns {Promise<void>}
         */
        async finalizeCombinedRecommendation() {
            const pending = this.pendingCombinedRecommendation
            if (!pending || pending.finalizing) {
                return
            }

            pending.finalizing = true
            this.pendingCombinedRecommendation = null

            const showOverlay = !pending.deleteSettled
            if (showOverlay) {
                this.$overlay.loading({ skipTimeout: true })
            }

            let deleted = false
            try {
                deleted = await pending.deletePromise
            } finally {
                if (showOverlay) {
                    this.$overlay.hide()
                }
            }

            const created = pending.addResult ? pending.addResult.created : 0
            const failed = pending.addResult ? pending.addResult.failed : 0

            if (!deleted) {
                this.$snackbar.error({
                    message: this.$t('timersproduct.recommendations.delete_expired.error'),
                    closeable: true
                })
            } else if (created > 0 && failed > 0) {
                this.$snackbar.warning({
                    closeable: true,
                    message: this.$t('timersproduct.recommendations.combined.success_partial', {
                        expired: pending.expiredCount,
                        added: created,
                        failed
                    })
                })
            } else if (created > 0) {
                this.$snackbar.progress({
                    closeable: true,
                    message: this.$t('timersproduct.recommendations.combined.success', {
                        expired: pending.expiredCount,
                        added: created
                    })
                })
            } else if (failed > 0) {
                this.$snackbar.error({
                    closeable: true,
                    message: this.$tc('timersproduct.timers_add_failed', failed, { n: failed })
                })
            } else {
                this.$snackbar.progress({
                    closeable: true,
                    message: this.$t('timersproduct.recommendations.delete_expired.success')
                })
            }

            this.resetRecommendationVisit()
        },
        /**
         * BUILD-7493 / BUILD-7492: abre el wizard de creación con los productos sugeridos.
         * Un producto → flujo actual de click en ficha; varios → colección temporal.
         *
         * @param {Array<Object>} [products]
         */
        startAddProductsRecommendation(products) {
            const items = Array.isArray(products) && products.length ? products : this.recommendedAddProducts
            if (!items.length) {
                this.dismissRecommendation()
                return
            }

            this.pendingRecommendedProductIds = items.map((product) => product.id)
            this.dismissRecommendation()
            this.show_timers = false
        },
        clearPendingRecommendedProductIds() {
            this.pendingRecommendedProductIds = []
        },
        /**
         * Elimina todos los productos expirados de Desechar.
         * Muestra el overlay de carga; `skipTimeout` evita el “Wow! / Back to start?”
         * solo en este flujo. El aviso usa el snackbar compacto de añadir timers.
         *
         * @returns {Promise<void>}
         */
        async deleteExpiredRecommendationTimers() {
            if (this.isDeletingExpiredRecommendation) {
                return
            }

            this.isDeletingExpiredRecommendation = true
            this.$overlay.loading({ skipTimeout: true })

            try {
                const deleted = await this.$store.dispatch('timerproduct/deleteExpiredTimers')
                if (!deleted) {
                    this.$snackbar.error({
                        message: this.$t('timersproduct.recommendations.delete_expired.error'),
                        closeable: true
                    })
                    return
                }

                this.closePopupTimer()
                this.dismissRecommendation()
                this.$snackbar.progress({
                    closeable: true,
                    message: this.$t('timersproduct.recommendations.delete_expired.success')
                })
            } catch (error) {
                logError('Error al eliminar productos expirados desde la recomendación:', error)
                this.$snackbar.error({
                    message: this.$t('timersproduct.recommendations.delete_expired.error'),
                    closeable: true
                })
            } finally {
                this.$overlay.hide()
                this.isDeletingExpiredRecommendation = false
            }
        },
        // MULTISTATUS feature flag (applies only for timers with one quantity)
        isMultiStatusFlagEnabled(timer) {
            if (!timer) {
                return false
            }

            const productHasTheFlag = timer.reference_config && timer.reference_config.multistatus && Number(timer.reference_config.multistatus) === 1

            return productHasTheFlag
        },
        verifyQuantityInitial() {
            return this.previewUnitsAvailable > 1
        },
        /** Borrado por unidades no aplica a multistatus (siempre eliminación completa del timer). */
        verifyDeleteQuantityControlsEnabled() {
            const timer = this.getTimers[this.keyTimer]
            if (this.isMultiStatusFlagEnabled(timer)) {
                return false
            }
            return this.verifyQuantityInitial()
        },
        verifyQuantityInitialLabel() {
            const quantity = this.previewTimer.quantity
            if (quantity === 1 || quantity === '1') {
                return false
            }
            return true
        },
        increaseMoveQuantity(variableName) {
            if (this.hasOwnProperty(variableName)) {
                if (variableName === 'addUnitsCount') {
                    if (this.addUnitsCount < 99) {
                        this.addUnitsCount++
                    }
                    return
                }
                const maxValue = this.previewUnitsAvailable
                this[variableName] = Math.min(maxValue, this[variableName] + 1)
            }
        },
        decreaseMoveQuantity(variableName) {
            if (this.hasOwnProperty(variableName)) {
                if (variableName === 'addUnitsCount') {
                    this.addUnitsCount = Math.max(1, this.addUnitsCount - 1)
                    return
                }
                this[variableName] = Math.max(1, this[variableName] - 1)
            }
        },
        timerReferenceAllowsAddUnits(timer) {
            if (!timer || !timer.reference_id) {
                return false
            }
            const refConfig = timer.reference_config || (this.$store.getters['timerproduct/getProducts'](timer.reference_id) || {}).reference_config
            return !!(refConfig && refConfig.add_units === true)
        },
        /**
         * Misma regla que TimerGroupModal.isTimerLive: el timer sigue activo (no caducado).
         */
        isTimerLive(timer) {
            if (!timer) {
                return false
            }
            return timer.status !== TIMERPRODUCT_STATUS.EXPIRED
        },
        /**
         * Suma unidades al timer, persiste vía store y muestra toasts; el callback solo aplica UI concreta tras éxito.
         * @param {string} timerId
         * @param {number|string} rawCount cantidad a añadir (se normaliza a entero ≥ 1)
         * @param {function} onSuccess ({ addCount, newQ, newQa, productName, timerId }) => void
         */
        async applyAddUnitsToTimer(timerId, rawCount, onSuccess) {
            const timers = this.getTimers
            const timer = timers[timerId]
            if (!timer || !timer.data || !this.timerReferenceAllowsAddUnits(timer)) {
                return
            }
            if (!this.isTimerLive(timer)) {
                return
            }
            const n = parseInt(rawCount, 10)
            const addCount = !isNaN(n) && n > 0 ? n : 1
            const q = parseInt(timer.data.quantity, 10)
            const qaRaw = timer.data.quantity_avaibles
            const qa = parseInt(qaRaw, 10)
            const baseQ = !isNaN(q) ? q : 0
            const baseQa = !isNaN(qa) ? qa : baseQ
            const newQ = String(baseQ + addCount)
            const newQa = String(baseQa + addCount)
            const productName = timer.data.product || ''

            this.$overlay.loading()
            try {
                const result = await this.$store.dispatch('timerproduct/updateTimer', {
                    id: timerId,
                    data: { quantity: newQ, quantity_avaibles: newQa }
                })
                if (result === false) {
                    this.$snackbar.error({
                        message: this.$t('timersproduct.add_units_error'),
                        closeable: true
                    })
                    return
                }
                this.$snackbar.success({
                    duration: 4000,
                    closeable: true,
                    message: this.$t(addCount === 1 ? 'timersproduct.add_units_success_unique' : 'timersproduct.add_units_success', addCount === 1 ? { name: productName } : { n: addCount, name: productName })
                })
                if (typeof onSuccess === 'function') {
                    onSuccess({ addCount, newQ, newQa, productName, timerId })
                }
            } catch (e) {
                this.$snackbar.error({
                    message: this.$t('timersproduct.add_units_error'),
                    closeable: true
                })
            } finally {
                this.$overlay.hide()
            }
        },
        async addUnitsToTimer() {
            await this.applyAddUnitsToTimer(this.keyTimer, this.addUnitsCount, ({ newQ, newQa }) => {
                this.previewTimer.quantity = newQ
                this.previewTimer.quantity_avaibles = newQa
                this.n++
                this.addUnitsCount = 1
                this.closePopupTimer()
            })
        },
        async handleGroupAddUnits(payload) {
            const timerId = payload && payload.timerId
            if (!timerId) {
                return
            }
            const rawCount = payload && payload.count
            await this.applyAddUnitsToTimer(timerId, rawCount, ({ timerId: id }) => {
                const updated = this.getTimers[id]
                if (this.selectedGroupTimer && this.selectedGroupTimer.id === id) {
                    this.selectedGroupTimer = updated
                    this.prepareGroupTimerPreview(updated)
                }
                this.closePopupGroupTimer()
            })
        },
        openModalChangeView() {
            this.isPopupOpen = true
            this.currentVisibilityBefore = this.currentVisibility
            this.showProductImagesBefore = this.showProductImages
        },
        showAlertLongTimer() {
            this.clickEnabledMulti = true
        },
        load() {
            let self = this

            this.$overlay.loading()

            // Asegurar que las categorías y productos estén cargados antes de cargar timers
            this.$store
                .dispatch('timerproduct/loadTimerProducts')
                .then(() => {
                    this.$store
                        .dispatch('timerproduct/loadTimers')
                        .then(() => {
                            self.selectCategory(false)
                            self.$overlay.hide()
                        })
                        .catch(() => {
                            // Si falla loadTimers, intentar seleccionar categoría de todos modos
                            self.selectCategory(false)
                            self.$overlay.hide()
                        })
                })
                .catch(() => {
                    // Si falla loadTimerProducts, intentar cargar timers de todos modos
                    this.$store
                        .dispatch('timerproduct/loadTimers')
                        .then(() => {
                            self.selectCategory(false)
                            self.$overlay.hide()
                        })
                        .catch(() => {
                            self.$overlay.hide()
                        })
                })

            if (!this.isApp) {
                this.checkPrinter(false, true)
            }
        },
        selectCategory(category) {
            var self = this
            self.$overlay.loading()
            this.$store.dispatch('timerproduct/selectCategory', category).then(() => {
                self.selectedCategory = category
                self.$overlay.hide()
            })

            self.$overlay.hide()
        },
        timerCreated() {
            this.show_timers = true
            setTimeout(() => {
                this.load()
            }, 1000)
        },
        changeVisibility(visibility) {
            this.currentVisibility = visibility
            // this.isPopupOpen = false

            const option = this.popupOptions.find((opt) => opt.value === this.currentVisibility)

            EventBus.$emit('update-title', { mensaje: this.$t('page_title.' + this.$route.name) + ` (${option.displayText})` })
        },
        /**
         * BUILD-7551: solo actualiza la preferencia visual de imágenes (draft del modal).
         * No altera currentVisibility ni la lógica de timers.
         */
        changeImageVisibility(showImages) {
            this.showProductImages = showImages === true
        },
        changeVisibilityEnd() {
            this.isPopupOpen = false
            this.persistViewPreferences()

            const option = this.popupOptions.find((opt) => opt.value === this.currentVisibility)

            EventBus.$emit('update-title', { mensaje: this.$t('page_title.' + this.$route.name) + ` (${option.displayText})` })
        },
        closePopup() {
            this.isPopupOpen = false
            this.currentVisibility = this.currentVisibilityBefore
            this.showProductImages = this.showProductImagesBefore
            const option = this.popupOptions.find((opt) => opt.value === this.currentVisibility)

            EventBus.$emit('update-title', { mensaje: this.$t('page_title.' + this.$route.name) + ` (${option.displayText})` })
        },
        /**
         * BUILD-7551: clave de preferencias de vista por usuario (localStorage).
         */
        viewPreferencesStorageKey() {
            const userId = this.$store.getters['loginUser/getLocalEmployee'] || 'anonymous'
            return 'timerproduct_view_prefs_' + userId
        },
        /**
         * BUILD-7551: restaura visibilidad + imágenes al entrar al módulo.
         */
        restoreViewPreferences() {
            try {
                const raw = localStorage.getItem(this.viewPreferencesStorageKey())
                if (!raw) {
                    return
                }
                const prefs = JSON.parse(raw)
                if (prefs && (prefs.currentVisibility === 1 || prefs.currentVisibility === 2)) {
                    this.currentVisibility = prefs.currentVisibility
                    this.currentVisibilityBefore = prefs.currentVisibility
                }
                if (prefs && typeof prefs.showProductImages === 'boolean') {
                    this.showProductImages = prefs.showProductImages
                    this.showProductImagesBefore = prefs.showProductImages
                }
            } catch (error) {
                // Preferencia corrupta: se mantiene el default sin romper el board.
            }
        },
        /**
         * BUILD-7551: persiste la vista al pulsar Aplicar.
         */
        persistViewPreferences() {
            try {
                localStorage.setItem(
                    this.viewPreferencesStorageKey(),
                    JSON.stringify({
                        currentVisibility: this.currentVisibility,
                        showProductImages: this.showProductImages === true
                    })
                )
            } catch (error) {
                // Sin espacio / modo privado: no bloqueamos el flujo de UI.
            }
        },
        showPopupOptionsTimer(id) {
            this.movedTimerCount1 = 1
            this.movedTimerCount2 = 1
            this.printedTimerCount = 1
            this.deletedTimerCount = 1
            this.movedBackTimerCount = 1
            this.addUnitsCount = 1
            const timers = this.$store.getters['timerproduct/getTimers']

            // Verificar si el timer pertenece a un grupo
            if (this.isTimerInGroup(id)) {
                this.showPopupGroupTimer(id)
                return
            }

            // DESELECCIONAR TODOS LOS TIMERS ANTES DE ABRIR EL MODAL
            Object.keys(timers).forEach((timerId) => {
                if (timers[timerId].isSelected) {
                    this.$store.commit('timerproduct/toggleTimerSelected', { timerId: timerId, forceFalse: true })
                }
            })

            // Desactivar el modo de selección múltiple
            this.clickEnabledMulti = false

            // Resetear el estado selectAll de todas las columnas
            this.columns.forEach((column) => {
                column.selectAll = false
            })

            this.canPrintTimer = false
            this.canMoveTimer = false
            this.canMoveBackTimer = false
            this.nextMoveTimer = false
            this.previousMoveTimer = false

            if (timers[id]) {
                const product = this.$store.getters['timerproduct/getProducts'](timers[id].reference_id)

                const stateCfg = this.resolveTimerProductState(product, timers[id])
                this.canPrintTimer = stateCfg && parseInt(stateCfg.type) == 3
                const formatId = stateCfg ? stateCfg.format : null
                const format = this.resolveFormatForTimerPreview(formatId)
                const data = { ...timers[id].data }
                const { previewData } = this.buildTimerLabelPreview({ format, data, product, previewTarget: 'single' })
                this.previewTimer = previewData || {}

                this.keyTimer = id
                this.showUnitsQuantityInPopup = !this.isMultiStatusFlagEnabled(timers[id])

                this.n++

                let timer = timers[id]
                if (timer.status > TIMERPRODUCT_STATUS.EXPIRED) {
                    //get state where id is equal to timer.state from this.columns
                    let posState = 0
                    let currentStateOrder = -1
                    let currentStateId = -1
                    this.columns.forEach((state, index) => {
                        if (state.id == timer.state) {
                            // posState = index
                            currentStateOrder = state.order
                            currentStateId = state.id
                        } else if (state.id && state.channel) {
                            let idState = this.timerProductStateBaseId(state.id)
                            if (idState == timer.state && ((!timer.data.channel && state.channel == 1) || timer.data.channel == state.channel)) {
                                // posState = index
                                currentStateOrder = state.order
                                currentStateId = state.id
                            }
                        }
                    })

                    let previousStateColumnId = false
                    let previousState = false
                    let previousStateName = false
                    let previousStateOrder = -1

                    // Encontrar el estado anterior con el orden más alto pero menor que el actual
                    this.columns.forEach((state) => {
                        if (state.order < currentStateOrder && state.order > previousStateOrder) {
                            previousStateColumnId = state.id
                            previousState = this.timerProductStateBaseId(state.id)
                            previousStateName = state.name
                            previousStateOrder = state.order
                        }
                    })

                    if (previousStateColumnId) {
                        let bPreviousStateFound = typeof this.$store.getters['timerproduct/getProducts'](timer.reference_id).states[previousState] !== 'undefined'
                        if (bPreviousStateFound && previousState == timer.data.moved_from_state && this.isUiMoveBackAllowed(timer.reference_id, timer)) {
                            this.previousMoveTimer = { name: previousStateName, id: previousStateColumnId }
                            this.canMoveBackTimer = true
                        } else {
                            this.previousMoveTimer = false
                            this.canMoveBackTimer = false
                        }
                    } else {
                        this.previousMoveTimer = false
                        this.canMoveBackTimer = false
                    }
                    // let posState = this.columns.findIndex((state) => state.id == timer.state)
                    if (posState < this.columns.length - 1) {
                        let bFound = false
                        let nextState = false
                        let nexStateName = false
                        while (posState < this.columns.length) {
                            if (this.columns[posState].order >= currentStateOrder && this.columns[posState].id != currentStateId) {
                                nextState = this.columns[posState].id
                                if (nextState) {
                                    nextState = this.timerProductStateBaseId(nextState)
                                    nexStateName = this.columns[posState].name
                                    let bStateFound = typeof this.$store.getters['timerproduct/getProducts'](timer.reference_id).states[nextState] !== 'undefined'
                                    if (bStateFound) {
                                        bFound = bStateFound
                                        this.canMoveTimer = timer.status != TIMERPRODUCT_STATUS.PREPARATION
                                        if (!Array.isArray(this.nextMoveTimer)) {
                                            this.nextMoveTimer = []
                                        }
                                        this.nextMoveTimer.push({ name: nexStateName, id: this.columns[posState].id })
                                        this.showMoveTimer = true
                                    }
                                }
                            }
                            posState++
                        }
                        if (!bFound) {
                            //TODO
                            this.canMoveTimer = false
                            this.showMoveTimer = false
                        }
                    } else {
                        //TODO
                        this.canMoveTimer = false
                        this.showMoveTimer = false
                    }
                } else {
                    //TODO
                    this.canMoveTimer = false
                    this.canPrintTimer = false
                    this.showMoveTimer = false
                }
            }
            this.popupTimerOpen = true
        },
        closePopupTimer() {
            this.popupTimerOpen = false
            this.isZplPreview = false
        },
        printerStoreAccessors() {
            return createPrinterStoreAccessors(this.$store)
        },
        isValidZPL(zpl) {
            return isValidZplString(zpl)
        },
        resolveTimerProductState(product, timer) {
            if (!product || !product.states || !timer) return null
            const states = product.states
            if (states[timer.state]) return states[timer.state]
            const baseStateId = this.timerProductStateBaseId(timer.state)
            if (baseStateId && states[baseStateId]) return states[baseStateId]
            return null
        },
        resolveFormatForTimerPreview(formatId) {
            if (!formatId) return null
            const currentConfigId = this.$store.getters['printer/getCurrentPrinter']
            const currentPrinterConfig = currentConfigId
                ? this.$store.getters['printer/getPrinterConfig'](currentConfigId)
                : null
            return this.resolveFormatForTimerPrint(formatId, currentPrinterConfig)
        },
        extractZPLFromPrinter(format, printer) {
            return extractZPLFromPrinterUtil(format, printer, this.printerStoreAccessors())
        },
        buildTimerPreviewParams(data, product) {
            const oLocation = this.$store.getters['loginUser/getLocalLocation'] || {}
            const params = { ...(data || {}) }
            params.account = oLocation.account_name || ''
            params.location = oLocation.name || ''
            params.city = oLocation.city || ''
            params.address = oLocation.address || ''
            params.loc_state = oLocation.state || ''
            params.cp = oLocation.cp || ''
            if (product && product.name && !params.product) {
                params.product = product.name
            }
            if (!params.quantity && data && data.quantity) {
                params.quantity = data.quantity
            }
            return params
        },
        openZplPreview({ zpl, format, labelName, params, resolvedPreviewFields, target = 'single' }) {
            const state = buildZplPreviewState({ zpl, format, labelName, params, resolvedPreviewFields })
            const nextZplKey = (target === 'group' ? this.groupZplKey : this.zplKey) + 1

            if (target === 'group') {
                this.groupZpl = state.zpl
                this.groupDensity = state.density
                this.groupLabelWidth = state.labelWidth
                this.groupLabelHeight = state.labelHeight
                this.groupZplValues = state.zplValues
                this.groupZplParams = state.zplParams
                this.groupZplKey = nextZplKey
                this.groupIsZplPreview = true
            } else {
                this.zpl = state.zpl
                this.density = state.density
                this.labelWidth = state.labelWidth
                this.labelHeight = state.labelHeight
                this.zplValues = state.zplValues
                this.zplParams = state.zplParams
                this.zplKey = nextZplKey
                this.isZplPreview = true
            }
        },
        enrichTimerDataWithDates(data) {
            const keys = Object.keys(data)
            for (const key of keys) {
                if (key.endsWith('_timestamp') || key.endsWith('_day') || key.endsWith('_time') || /_d[1-7]$/.test(key)) {
                    continue
                }
                if (
                    !key.includes('caducidad') &&
                    !key.includes('date') &&
                    !key.includes('print_date') &&
                    !key.includes('prep_date')
                ) {
                    continue
                }
                const timestampKey = key + '_timestamp'
                if (!data[timestampKey]) continue
                const aux = moment(data[timestampKey] * 1000)
                data[key + '_day'] = aux.format('DD/MM/YYYY')
                data[key + '_time'] = aux.format('HH:mm')
                for (let i = 1; i <= 7; i++) {
                    data[key + '_d' + i] = aux.isoWeekday() === i ? 'x' : ' '
                }
            }
        },
        processRealisticPreviewFields(newPreviewStructure, values, data) {
            if (!newPreviewStructure || !newPreviewStructure.fields) return
            newPreviewStructure.fields.forEach((el) => {
                if (el.f_id && values[el.f_id]) {
                    const regex = /[\{|\[][a-zA-Z0-9_\}|\]]*/gi
                    let val = values[el.f_id]
                    let value = val

                    if (values[el.f_id].match(/[\{\}\[\]]/gi)) {
                        let m
                        while ((m = regex.exec(val)) !== null) {
                            if (m.index === regex.lastIndex) regex.lastIndex++
                            m.forEach((match) => {
                                const index = match.replace(/[\{\}\[\]]/gi, '')
                                value = value.replace(match, data[index] == null ? '' : String(data[index]))
                                if (el.format && el.type === 'barcode' && !moment(value, el.format, true).isValid()) {
                                    value = moment(value, 'DD/MM/YYYY HH:mm').format(el.format)
                                }
                            })
                        }
                        el.current = false
                    }

                    el.value = el.format && el.type !== 'barcode' ? formatPrintedDateFromStore(value, el.format) : value
                } else if (el.value && el.value.match(/[\{\}\[\]]/gi)) {
                    const regex = /[\{|\[][a-zA-Z0-9_\}|\]]*/gi
                    let val = el.value
                    let value = val
                    let m
                    while ((m = regex.exec(val)) !== null) {
                        if (m.index === regex.lastIndex) regex.lastIndex++
                        m.forEach((match) => {
                            const index = match.replace(/[\{\}\[\]]/gi, '')
                            value = value.replace(match, data[index] == null ? '' : String(data[index]))
                            if (el.format && el.type === 'barcode' && !moment(value, el.format, true).isValid()) {
                                value = moment(value, 'DD/MM/YYYY HH:mm').format(el.format)
                            }
                        })
                    }
                    el.current = false
                    el.value = el.format && el.type !== 'barcode' ? formatPrintedDateFromStore(value, el.format) : value
                }
            })
        },
        buildTimerLabelPreview({ format, data, product, previewTarget = 'single' }) {
            try {
                if (!format) {
                    return { previewData: {}, isZpl: false }
                }

                const enrichedData = { ...(data || {}) }
                this.enrichTimerDataWithDates(enrichedData)

                const newPreviewStructure = format.realistic_preview ? JSON.parse(format.realistic_preview) : false
                let previewData = {}
                const values = JSON.parse(format.data || '{}')

                if (newPreviewStructure) {
                    const structure = JSON.parse(JSON.stringify(newPreviewStructure))
                    this.processRealisticPreviewFields(structure, values, enrichedData)
                    previewData = Object.assign({}, structure)
                }

                previewData.quantity = enrichedData.quantity
                previewData.quantity_avaibles = enrichedData.quantity_avaibles ? enrichedData.quantity_avaibles : enrichedData.quantity

                if (previewData.fields && previewData.fields.length > 0 && enrichedData.package) {
                    this.adjustProductPackageFields(previewData, product, enrichedData)
                }

                if (previewTarget === 'group') {
                    this.groupIsZplPreview = false
                } else {
                    this.isZplPreview = false
                }

                let isZpl = false
                try {
                    const printer =
                        Object.keys(this.$store.getters['printer/getPrinter'] || {}).length > 0
                            ? this.$store.getters['printer/getPrinter']
                            : this.$store.getters['login/getPrinter']
                    const extracted = this.extractZPLFromPrinter(format, printer)
                    const zpl = extracted && extracted.zpl ? extracted.zpl : null
                    const labelName = extracted && extracted.labelName ? extracted.labelName : null

                    if (zpl && this.isValidZPL(zpl)) {
                        const params = this.buildTimerPreviewParams(enrichedData, product)
                        this.openZplPreview({
                            zpl,
                            format,
                            labelName,
                            params,
                            resolvedPreviewFields: previewData.fields,
                            target: previewTarget
                        })
                        isZpl = true
                    }
                } catch (e) {
                    isZpl = false
                }

                return { previewData, isZpl }
            } catch (error) {
                return { previewData: {}, isZpl: false }
            }
        },
        /**
         * Clave en product.states y comparaciones de flujo: quita el sufijo `_channel…` si existe.
         * No usar split('_')[0]: truncaría IDs base con guiones bajos (p. ej. abc_def_channel1 → abc).
         *
         * @param {string|number|null|undefined} stateId
         * @returns {string|number|null|undefined}
         */
        timerProductStateBaseId(stateId) {
            return timerProductStateBaseIdUtil(stateId)
        },
        /**
         * Permite fusionar cantidades al devolver el timer al estado anterior tras superar
         * el timeout configurado (timer_product_time_out), solo si el backend envía
         * reference_config.can_move_past === 1 en el producto/referencia.
         */
        productAllowsMovePastTimeout(referenceId) {
            const product = this.$store.getters['timerproduct/getProducts'](referenceId)
            return referenceCanMovePast(product)
        },
        /**
         * Dentro de la ventana timer_product_time_out desde prep_date_timestamp (misma idea que moveTimerNextState).
         */
        isWithinPrepReturnTimeout(timer) {
            if (!timer || !timer.data || timer.data.prep_date_timestamp == null || timer.data.prep_date_timestamp === '') {
                return false
            }
            const serverTimeDifference = this.$store.getters['getServerTimeDifference']
            const currentTime = moment(moment().add(serverTimeDifference, 'minutes')).unix()
            const rawPrep = timer.data.prep_date_timestamp
            let prepMoment
            if (typeof rawPrep === 'number' && rawPrep > 0 && rawPrep < 1e12) {
                prepMoment = moment.unix(rawPrep)
            } else {
                prepMoment = moment(rawPrep)
            }
            if (!prepMoment.isValid()) {
                return false
            }
            const prepTimeUnix = prepMoment.unix()
            const timeDiffMinutes = Math.abs(Math.floor((currentTime - prepTimeUnix) / 60))
            const timeoutMinutes = this.getTimeOutTimer
            if (timeoutMinutes === 0) {
                return true
            }
            return timeDiffMinutes <= timeoutMinutes
        },
        /**
         * Mostrar / permitir UI de devolución al estado anterior: can_move_past o aún dentro del timeout de prep.
         */
        isUiMoveBackAllowed(referenceId, timer) {
            if (this.productAllowsMovePastTimeout(referenceId)) {
                return true
            }
            return this.isWithinPrepReturnTimeout(timer)
        },
        /**
         * Solo si el producto tiene can_move_past y se devuelven todas las unidades del timer hijo en esa
         * operación: copiar snapshots al padre para el siguiente avance a mesa. Devolución parcial o productos
         * sin la opción → vacío (solo cantidades, comportamiento habitual).
         * Implementación: buildCaducidadSnapshotsForParentFromChild (utils), compartida con el store.
         */
        caducidadSnapshotsForParentFromChild(childTimer, todasLasUnidadesDelHijoDevueltas) {
            const product = childTimer && childTimer.reference_id != null ? this.$store.getters['timerproduct/getProducts'](childTimer.reference_id) : null
            const childData = childTimer && childTimer.data ? childTimer.data : null
            return buildCaducidadSnapshotsForParentFromChild(product, childData, todasLasUnidadesDelHijoDevueltas)
        },
        buildParentUpdateDataForChannelMerge(childTimer, parentTimer, currentState, nextState, todasLasUnidadesDelHijoDevueltas, baseData = {}) {
            const data = { ...baseData }
            const product = childTimer && childTimer.reference_id != null ? this.$store.getters['timerproduct/getProducts'](childTimer.reference_id) : null
            const productStates = product && product.states ? product.states : null
            if (shouldPreserveTimerDatesOnMove(currentState, nextState, childTimer, productStates) && childTimer && parentTimer) {
                Object.assign(data, buildChannelMergeDateFields(childTimer.data, parentTimer.data))
            }
            Object.assign(data, this.caducidadSnapshotsForParentFromChild(childTimer, todasLasUnidadesDelHijoDevueltas))
            return data
        },
        isChannelOnlyMoveForColumns(currentState, nextState, timer) {
            if (!currentState || !nextState || !timer) {
                return false
            }
            const product = this.$store.getters['timerproduct/getProducts'](timer.reference_id)
            const productStates = product && product.states ? product.states : null
            return shouldPreserveTimerDatesOnMove(currentState, nextState, timer, productStates)
        },
        getChannelMoveDatePayload(sourceData, currentState, nextState, timer) {
            if (!sourceData || !currentState || !nextState || !timer) {
                return {}
            }
            const product = this.$store.getters['timerproduct/getProducts'](timer.reference_id)
            const productStates = product && product.states ? product.states : null
            if (!shouldPreserveTimerDatesOnMove(currentState, nextState, timer, productStates)) {
                return {}
            }
            return getTimerDateFieldsForPayload(sourceData)
        },
        /**
         * Columna del tablero donde está el timer (alineado con prepareGroupMoveOptions).
         * El filter antiguo solo contemplaba _channel1 explícito y channel en data; los timers
         * agrupados en columnas canal a menudo no coincidían → currentState undefined → sin modal de impresión.
         */
        resolveColumnForTimerState(timer) {
            if (!timer || !this.columns || this.columns.length === 0) {
                return null
            }
            for (const state of this.columns) {
                if (state.id == timer.state) {
                    return state
                }
                if (state.id && state.channel) {
                    const idState = String(state.id).split('_')[0]
                    // eslint-disable-next-line eqeqeq
                    if (idState == timer.state && ((!timer.data.channel && state.channel == 1) || timer.data.channel == state.channel)) {
                        return state
                    }
                }
            }
            return null
        },
        /**
         * Columna del tablero para un estado destino (id exacto o base + canal como resolveColumnForTimerState).
         * Sin timer o sin coincidencia por canal, el primer fallo impedía encontrar columnas sólo `_channelN`
         * y rompía merge/delete al mover hacia atrás con params.next_state en forma base ("2").
         */
        resolveColumnForNextStateId(nextStateIdParam, timer = null) {
            if (nextStateIdParam == null || !this.columns || this.columns.length === 0) {
                return null
            }
            const exact = this.columns.find((s) => s.id == nextStateIdParam)
            if (exact) {
                return exact
            }
            const baseTarget = String(nextStateIdParam).split('_')[0]

            const plain = this.columns.find((s) => s.id == baseTarget)
            if (plain) {
                return plain
            }

            if (timer && timer.data) {
                for (const state of this.columns) {
                    if (!state.id || !state.channel) {
                        continue
                    }
                    const idState = String(state.id).split('_')[0]
                    // eslint-disable-next-line eqeqeq
                    if (idState == baseTarget && ((!timer.data.channel && state.channel == 1) || timer.data.channel == state.channel)) {
                        return state
                    }
                }
            }

            return this.columns.find((s) => s.id && String(s.id).split('_')[0] === baseTarget) || null
        },
        /**
         * Estado destino del producto (clave numérica o string, con o sin sufijo _channel).
         */
        getProductStateForTimerMove(product, nextStateIdParam) {
            if (!product || !product.states || nextStateIdParam == null) {
                return null
            }
            const key = String(nextStateIdParam).split('_')[0]
            return product.states[key] || product.states[Number(key)] || null
        },
        /**
         * ¿Mostrar el popup de confirmación antes de imprimir tras un movimiento?
         * No si es el mismo estado, si vuelves al moved_from_state, o si el destino va hacia atrás
         * en el tablero (order de columnas). El order en product.states puede no seguir el flujo real
         * y rompía el merge de la última unidad hacia impresión.
         * @param {Object|null} timer — timer que se mueve (para moved_from_state); opcional.
         */
        shouldOfferPrintConfirmAfterMove(product, nextStateIdParam, currentStateColumn, timer = null) {
            if (!product || !currentStateColumn || nextStateIdParam == null || !product.states) {
                return false
            }
            const destState = this.getProductStateForTimerMove(product, nextStateIdParam)
            if (!destState) {
                return false
            }
            const destKey = String(nextStateIdParam).split('_')[0]
            const srcKey = String(currentStateColumn.id).split('_')[0]
            if (destKey === srcKey) {
                return false
            }
            if (timer && timer.data && timer.data.moved_from_state != null && String(timer.data.moved_from_state).trim() !== '') {
                const mfKey = String(timer.data.moved_from_state).split('_')[0]
                if (destKey === mfKey) {
                    return false
                }
            }
            const destBoardColumn = this.resolveColumnForNextStateId(nextStateIdParam, timer)
            const srcOrd = currentStateColumn.order
            const destOrd = destBoardColumn ? destBoardColumn.order : null
            if (srcOrd != null && destOrd != null && Number(destOrd) < Number(srcOrd)) {
                return false
            }
            return parseInt(destState.type, 10) === 3
        },
        /**
         * Cierra el popup del timer y abre el confirm de impresión.
         * @param {boolean} deferOpenForGhostClick — solo true al venir del botón Imprimir (popup timer o grupo):
         *   retrasa la apertura para no recibir el mismo clic en "Confirmar". Tras mover, false (solo $nextTick).
         */
        queuePrintConfirmModal(timerId, isAfterMove, deferOpenForGhostClick = false) {
            const self = this
            if (timerId === false || timerId === null || timerId === undefined) {
                this.closePopupTimer()
                return
            }
            if (this.groupMoveCollectingPrintConfirmIds) {
                const key = String(timerId)
                if (!this.pendingGroupMovePrintTimerIds.some((id) => String(id) === key)) {
                    this.pendingGroupMovePrintTimerIds.push(timerId)
                }
                this.pendingPrintIsAfterMove = this.pendingPrintIsAfterMove || !!isAfterMove
                return
            }
            this.pendingPrintIsAfterMove = !!isAfterMove
            this.pendingBatchPrintTimerIds = null
            this.closePopupTimer()
            const openPrintConfirm = () => {
                self.newTimerToPrint = timerId
                self.isPopupToPrintTimerOpen = true
            }
            this.$nextTick(() => {
                if (deferOpenForGhostClick) {
                    window.setTimeout(openPrintConfirm, 150)
                } else {
                    openPrintConfirm()
                }
            })
        },
        /**
         * Confirmación antes de imprimir varios timers (modal de grupo u otros flujos por lotes).
         * @param {boolean} isAfterMove — true si el confirm sigue a mover de columna (copias en printLabel).
         */
        queueBatchPrintConfirmModal(timerIds, deferOpenForGhostClick = false, isAfterMove = false) {
            if (!timerIds || timerIds.length === 0) {
                this.closePopupTimer()
                return
            }
            this.pendingPrintIsAfterMove = !!isAfterMove
            this.pendingBatchPrintTimerIds = [...timerIds]
            this.closePopupTimer()
            const self = this
            const openPrintConfirm = () => {
                self.newTimerToPrint = timerIds[0]
                self.isPopupToPrintTimerOpen = true
            }
            this.$nextTick(() => {
                if (deferOpenForGhostClick) {
                    window.setTimeout(openPrintConfirm, 150)
                } else {
                    openPrintConfirm()
                }
            })
        },
        /** Imprimir desde el popup del timer: siempre pasa por el modal de confirmación. */
        requestTimerPrintConfirm(timerId) {
            this.queuePrintConfirmModal(timerId, false, true)
        },
        getNextAvailableLetter(timerId) {
            const timers = this.$store.getters['timerproduct/getTimers']
            const currentTimer = timers[timerId]
            const timersByCategory = Object.values(timers).filter((timer) => timer.reference_id === currentTimer.reference_id)

            // Extraer letras existentes y ordenarlas
            const existingLetters = timersByCategory
                .map((timer) => timer.data.letter_relation)
                .filter((letter) => letter)
                .sort()

            // Si no hay letras existentes, empezar con 'A'
            if (existingLetters.length === 0) {
                return 'A'
            }

            // Encontrar el primer hueco en la secuencia
            let expectedCharCode = 'A'.charCodeAt(0)
            for (let letter of existingLetters) {
                const currentCharCode = letter.charCodeAt(0)
                if (currentCharCode > expectedCharCode) {
                    // Encontramos un hueco, retornar la letra faltante
                    return String.fromCharCode(expectedCharCode)
                }
                expectedCharCode = currentCharCode + 1
            }

            // Si no hay huecos, retornar la siguiente letra después de la última
            return String.fromCharCode(expectedCharCode)
        },
        getStateNameById(stateId) {
            const found = this.columns.find((state) => state.id == stateId)
            return found ? found.name : ''
        },
        buildMoveTimerContext(params) {
            const timerId = params.timer_id
            const nextStateId = params.next_state
            const indexField = params.index
            const skipPopupAndClose = params.skipPopupAndClose || false
            const timers = this.$store.getters['timerproduct/getTimers']
            const sourceTimer = timers[timerId]
            const isBackwardMove = Boolean(this.previousMoveTimer && params.next_state === this.previousMoveTimer.id) || params.isBackwardMove === true
            const canProceed = Boolean(timers[timerId] && (this.canMoveTimer || (isBackwardMove && this.canMoveBackTimer)))

            let nextLetter
            if (sourceTimer && sourceTimer.data && !sourceTimer.data.letter_relation) {
                nextLetter = this.getNextAvailableLetter(timerId)
            } else if (sourceTimer && sourceTimer.data) {
                nextLetter = sourceTimer.data.letter_relation
            }

            const colorRelation = sourceTimer && sourceTimer.data && sourceTimer.data.color_relation ? sourceTimer.data.color_relation : 0

            let timer = null
            let currentState = null
            let nextState = null

            if (canProceed && sourceTimer) {
                timer = { ...sourceTimer }
                currentState = this.resolveColumnForTimerState(timer)
                nextState = this.resolveColumnForNextStateId(nextStateId, timer)
            }

            return {
                timerId,
                nextStateId,
                indexField,
                skipPopupAndClose,
                timers,
                sourceTimer,
                timer,
                currentState,
                nextState,
                isBackwardMove,
                canProceed,
                isMultiStatusFlagEnabled: this.isMultiStatusFlagEnabled(sourceTimer),
                productName: sourceTimer && sourceTimer.data && sourceTimer.data.product ? sourceTimer.data.product : '',
                currentStateName: sourceTimer ? this.getStateNameById(sourceTimer.state) : '',
                nextStateName: this.getStateNameById(nextStateId),
                nextLetter,
                colorRelation
            }
        },
        rejectMove(ctx, { respectSkipPopup = false } = {}) {
            this.$snackbar.error({
                closeable: true,
                message: this.$t('timersproduct.cannot_move')
            })
            if (!respectSkipPopup || !ctx.skipPopupAndClose) {
                this.closePopupTimer()
            }
            return Promise.resolve()
        },
        getMoveQuantityFromIndex(indexField) {
            return computeQuantityMove({
                movedBackTimerCount: this.movedBackTimerCount,
                indexField,
                movedTimerCount1: this.movedTimerCount1,
                movedTimerCount2: this.movedTimerCount2
            })
        },
        finalizeMoveWithPrintOrClose({ printTimerId, referenceId, nextStateId, currentState, timer, skipPopupAndClose }) {
            const product = this.$store.getters['timerproduct/getProducts'](referenceId)
            const canPrintTimer = this.shouldOfferPrintConfirmAfterMove(product, nextStateId, currentState, timer)

            if (canPrintTimer) {
                this.queuePrintConfirmModal(printTimerId, true)
            } else if (!skipPopupAndClose) {
                this.closePopupTimer()
            }
        },
        mergeQuantityWithParent({ timerId, timer, parentTimer, nextStateId, currentState, nextState, skipPopupAndClose, prependPromise = null, indexField }) {
            const self = this

            timer.quantity_move = this.getMoveQuantityFromIndex(indexField)

            const unitAvaibles = computeRemainingUnits(timer.data, timer.quantity_move)
            const newQuantityAvaibles = computeNewParentQuantity(timer.quantity_move, parentTimer.data.quantity_avaibles)
            const allUnitsMoved = shouldDeleteSourceAfterMove(unitAvaibles, timer.data)

            const finalize = () => {
                self.finalizeMoveWithPrintOrClose({
                    printTimerId: parentTimer.id,
                    referenceId: timer.reference_id,
                    nextStateId,
                    currentState,
                    timer,
                    skipPopupAndClose
                })
            }

            if (allUnitsMoved) {
                const deleteAndUpdate = async () => {
                    if (prependPromise) {
                        await prependPromise
                    }
                    await self.$store.dispatch('timerproduct/deleteTimer', { id: timerId })
                    await self.$store.dispatch('timerproduct/updateTimer', {
                        id: parentTimer.id,
                        verify_relations: true,
                        data: self.buildParentUpdateDataForChannelMerge(timer, parentTimer, currentState, nextState, true, {
                            quantity_avaibles: newQuantityAvaibles
                        })
                    })
                }
                return deleteAndUpdate().then(finalize)
            }

            const updatePromises = [
                self.$store.dispatch('timerproduct/updateTimer', { id: timerId, data: { quantity_avaibles: unitAvaibles } }),
                self.$store.dispatch('timerproduct/updateTimer', {
                    id: parentTimer.id,
                    data: self.buildParentUpdateDataForChannelMerge(timer, parentTimer, currentState, nextState, false, {
                        quantity_avaibles: newQuantityAvaibles
                    })
                })
            ]

            if (prependPromise) {
                updatePromises.unshift(prependPromise)
            }

            return Promise.all(updatePromises).then(finalize)
        },
        evaluateMoveRelations(ctx) {
            const self = this
            const { timer, timers, timerId, nextStateId, currentState, nextState, skipPopupAndClose, colorRelation, nextLetter, indexField } = ctx

            const noRelation = { hasRelationId: false, bRemoveCurrentTimer: false, earlyPromise: null }
            const timersRelations = timer.data.timers_relations ? JSON.parse(timer.data.timers_relations) : []
            const hasTimersRelations = timersRelations.length > 0
            const hasTimerRelId = Boolean(timer.data.timer_rel_id)
            const isChannelMove = Boolean(currentState.channel && nextState.channel)

            if (!hasTimerRelId && !hasTimersRelations && !isChannelMove) {
                return noRelation
            }

            if (hasTimersRelations) {
                const nextStateIdClean = self.timerProductStateBaseId(nextState.id)
                const { parentTimer } = findParentTimerByRelations(timers, timer, nextStateIdClean)

                const updatePromise = self.$store.dispatch('timerproduct/updateTimer', {
                    id: timerId,
                    data: {
                        timers_relations: JSON.stringify(timersRelations),
                        color_relation: colorRelation,
                        letter_relation: nextLetter
                    }
                })

                if (!parentTimer) {
                    return {
                        hasRelationId: false,
                        bRemoveCurrentTimer: isChannelMove,
                        earlyPromise: null,
                        relationMetadataPromise: updatePromise
                    }
                }

                return {
                    hasRelationId: true,
                    bRemoveCurrentTimer: true,
                    earlyPromise: self.mergeQuantityWithParent({
                        timerId,
                        timer,
                        parentTimer,
                        nextStateId,
                        currentState,
                        nextState,
                        skipPopupAndClose,
                        prependPromise: updatePromise,
                        indexField
                    })
                }
            }

            if (!hasTimerRelId) {
                return { hasRelationId: false, bRemoveCurrentTimer: isChannelMove, earlyPromise: null }
            }

            const nextStateIdClean = self.timerProductStateBaseId(nextStateId)
            const parentTimer = findParentTimerByRelId(timers, timer, nextStateIdClean)

            if (!parentTimer) {
                return { hasRelationId: false, bRemoveCurrentTimer: isChannelMove, earlyPromise: null }
            }

            return {
                hasRelationId: true,
                bRemoveCurrentTimer: isChannelMove,
                earlyPromise: self.mergeQuantityWithParent({
                    timerId,
                    timer,
                    parentTimer,
                    nextStateId,
                    currentState,
                    nextState,
                    skipPopupAndClose,
                    indexField
                })
            }
        },
        prepareTimerForStoreMove(timer, timerId, indexField, currentState) {
            timer.quantity = timer.data.quantity
            timer.data.quantity = timer.data.quantity
            timer.quantity_avaible = timer.data.quantity_avaibles ? timer.data.quantity_avaibles : timer.data.quantity
            timer.quantity_move = this.getMoveQuantityFromIndex(indexField)

            if (currentState && currentState.channel) {
                timer.data.timer_rel_id = timerId
            }

            timer.isLoading = true
            return timer
        },
        handleExpiredTimerMove(ctx) {
            const { timerId, timer, nextStateId, currentState, skipPopupAndClose } = ctx
            if (timer) {
                timer.isLoading = false
            }
            this.finalizeMoveWithPrintOrClose({
                printTimerId: timerId,
                referenceId: timer.reference_id,
                nextStateId,
                currentState,
                timer,
                skipPopupAndClose
            })
            return Promise.resolve()
        },
        handleStoreMoveErrorResponse(response, skipPopupAndClose) {
            this.$snackbar.error({
                message: this.$t('config.printer.error_print_default'),
                closeable: true
            })
            if (!skipPopupAndClose) {
                this.closePopupTimer()
            }
            return response
        },
        validateStoreMoveResponse(response, skipPopupAndClose) {
            if (response === true) {
                if (!skipPopupAndClose) {
                    this.closePopupTimer()
                }
                return { ok: true, response }
            }

            if (response === false || response === null || response === undefined) {
                return { ok: false, response: this.handleStoreMoveErrorResponse(response, skipPopupAndClose) }
            }

            if (typeof response !== 'string' && typeof response !== 'number') {
                return { ok: false, response: this.handleStoreMoveErrorResponse(response, skipPopupAndClose) }
            }

            const movedTimerId = String(response)

            if (movedTimerId === '') {
                return { ok: false, response: this.handleStoreMoveErrorResponse(response, skipPopupAndClose) }
            }

            const timersUpdated = this.$store.getters['timerproduct/getTimers']
            const newTimer = timersUpdated[movedTimerId]

            if (!newTimer) {
                logError('moveTimerNextState: Timer no encontrado con ID:', movedTimerId)
                return { ok: false, response: this.handleStoreMoveErrorResponse(response, skipPopupAndClose) }
            }

            return { ok: true, response, movedTimerId, newTimer }
        },
        async applyPostStoreMoveUpdatesStandard({
            timer,
            timerId,
            movedTimerId,
            newTimer,
            currentState,
            nextStateId,
            colorRelation,
            nextLetter,
            isMultiStatusFlagEnabled,
            productName,
            currentStateName,
            nextStateName,
            channelDatePayload = {}
        }) {
            const self = this

            const timerRelations1 = timer.data.timers_relations ? JSON.parse(timer.data.timers_relations) : []
            const timerRelations2 = newTimer.data.timers_relations ? JSON.parse(newTimer.data.timers_relations) : []
            const { timersRelationsJson } = mergeTimersRelations({
                sourceRelations: timerRelations1,
                destRelations: timerRelations2,
                timerId,
                currentStateId: currentState.id,
                nextStateId
            })

            const availableUnits = computeRemainingUnits(timer.data, timer.quantity_move)
            const noUnitsLeftOnSource = shouldDeleteSourceAfterMove(availableUnits, timer.data)
            const commonData = {
                color_relation: colorRelation,
                letter_relation: nextLetter
            }

            if (noUnitsLeftOnSource && isMultiStatusFlagEnabled) {
                await self.$store.dispatch('timerproduct/updateTimer', {
                    id: timerId,
                    data: { ...commonData, quantity_avaibles: availableUnits }
                })
                await self.$store.dispatch('timerproduct/updateTimer', {
                    id: movedTimerId,
                    data: { ...commonData, timers_relations: timersRelationsJson, ...channelDatePayload }
                })
            } else if (noUnitsLeftOnSource) {
                await self.$store.dispatch('timerproduct/deleteTimer', { id: timerId })
                await self.$store.dispatch('timerproduct/updateTimer', {
                    id: timerId,
                    data: { ...commonData, quantity_avaibles: availableUnits }
                })
            } else {
                await self.$store.dispatch('timerproduct/updateTimer', {
                    id: timerId,
                    data: { ...commonData, quantity_avaibles: availableUnits }
                })
                await self.$store.dispatch('timerproduct/updateTimer', {
                    id: movedTimerId,
                    data: { ...commonData, timers_relations: timersRelationsJson, ...channelDatePayload }
                })
            }

            if (isMultiStatusFlagEnabled) {
                const snackbarMessage = self.$t('config.printer.multistatus_timer_move_snackbar', {
                    productName,
                    nextStateName,
                    currentStateName
                })
                self.$snackbar.info({ message: snackbarMessage })
            } else {
                let msg = self.$tc('config.printer.success_save', parseInt(timer.data.quantity))
                msg = msg.replace('[num_copies]', this.printedTimerCount)
                msg = msg.replace('[product]', timer.data.product)
                self.$snackbar.progress({ closeable: true, message: msg })
            }
        },
        async applyPostStoreMoveUpdatesRelationTimeout({
            timer,
            timerId,
            movedTimerId,
            newTimer,
            currentState,
            nextStateId,
            colorRelation,
            nextLetter,
            isMultiStatusFlagEnabled
        }) {
            const self = this

            const timerRelations1 = timer.data.timers_relations ? JSON.parse(timer.data.timers_relations) : []
            const timerRelations2 = newTimer.data.timers_relations ? JSON.parse(newTimer.data.timers_relations) : []
            const { columnExists, timersRelationsJson } = mergeTimersRelations({
                sourceRelations: timerRelations1,
                destRelations: timerRelations2,
                timerId,
                currentStateId: currentState.id,
                nextStateId
            })

            if (isMultiStatusFlagEnabled) {
                await self.$store.dispatch('timerproduct/updateTimer', {
                    id: movedTimerId,
                    data: {
                        timers_relations: timersRelationsJson,
                        color_relation: colorRelation,
                        letter_relation: nextLetter
                    }
                })
            } else if (!columnExists) {
                await self.$store.dispatch('timerproduct/updateTimer', {
                    id: movedTimerId,
                    data: {
                        timers_relations: timersRelationsJson,
                        color_relation: colorRelation,
                        letter_relation: nextLetter
                    }
                })
            }

            const availableUnits = computeRemainingUnits(timer.data, timer.quantity_move)
            const noUnitsLeftOnSource = shouldDeleteSourceAfterMove(availableUnits, timer.data)

            if (noUnitsLeftOnSource && isMultiStatusFlagEnabled) {
                await self.$store.dispatch('timerproduct/updateTimer', {
                    id: timerId,
                    data: {
                        quantity_avaibles: availableUnits,
                        color_relation: colorRelation,
                        letter_relation: nextLetter
                    }
                })
            } else if (noUnitsLeftOnSource) {
                await self.$store.dispatch('timerproduct/deleteTimer', { id: timerId })
            } else {
                await self.$store.dispatch('timerproduct/updateTimer', {
                    id: timerId,
                    data: {
                        quantity_avaibles: availableUnits,
                        ...(isMultiStatusFlagEnabled ? { color_relation: colorRelation, letter_relation: nextLetter } : {})
                    }
                })
            }

            let msg = self.$tc('config.printer.success_save', parseInt(timer.data.quantity))
            msg = msg.replace('[num_copies]', this.printedTimerCount)
            msg = msg.replace('[product]', timer.data.product)
            self.$snackbar.progress({ closeable: true, message: msg })
        },
        async handleStoreMoveResponse(ctx, response, responseMode) {
            const validation = this.validateStoreMoveResponse(response, ctx.skipPopupAndClose)
            if (!validation.ok) {
                return validation.response
            }

            if (response === true) {
                return validation.response
            }

            const { movedTimerId, newTimer } = validation

            if (responseMode === 'standard') {
                if (movedTimerId) {
                    await this.applyPostStoreMoveUpdatesStandard({
                        timer: ctx.timer,
                        timerId: ctx.timerId,
                        movedTimerId,
                        newTimer,
                        currentState: ctx.currentState,
                        nextStateId: ctx.nextStateId,
                        colorRelation: ctx.colorRelation,
                        nextLetter: ctx.nextLetter,
                        isMultiStatusFlagEnabled: ctx.isMultiStatusFlagEnabled,
                        productName: ctx.productName,
                        currentStateName: ctx.currentStateName,
                        nextStateName: ctx.nextStateName,
                        channelDatePayload: ctx.channelDatePayload
                    })
                } else {
                    this.handleStoreMoveErrorResponse(response, ctx.skipPopupAndClose)
                }
            } else {
                await this.applyPostStoreMoveUpdatesRelationTimeout({
                    timer: ctx.timer,
                    timerId: ctx.timerId,
                    movedTimerId,
                    newTimer,
                    currentState: ctx.currentState,
                    nextStateId: ctx.nextStateId,
                    colorRelation: ctx.colorRelation,
                    nextLetter: ctx.nextLetter,
                    isMultiStatusFlagEnabled: ctx.isMultiStatusFlagEnabled
                })
            }

            this.finalizeMoveWithPrintOrClose({
                printTimerId: newTimer.id,
                referenceId: ctx.timer.reference_id,
                nextStateId: ctx.nextStateId,
                currentState: ctx.currentState,
                timer: ctx.timer,
                skipPopupAndClose: ctx.skipPopupAndClose
            })

            return validation.response
        },
        dispatchStoreMoveTimer(ctx, responseMode) {
            const self = this
            const preserveTimerDates = self.isChannelOnlyMoveForColumns(ctx.currentState, ctx.nextState, ctx.timer)
            const channelDatePayload = self.getChannelMoveDatePayload(ctx.timer.data, ctx.currentState, ctx.nextState, ctx.timer)
            const moveCtx = { ...ctx, preserveTimerDates, channelDatePayload }

            self.$overlay.loading()

            return self.$store
                .dispatch('timerproduct/moveTimerNextState', {
                    timer: ctx.timer,
                    nextState: ctx.nextStateId,
                    preserveTimerDates: preserveTimerDates
                })
                .then(async (response) => {
                    self.$overlay.hide()
                    return self.handleStoreMoveResponse(moveCtx, response, responseMode)
                })
        },
        executeNoRelationMove(ctx) {
            this.prepareTimerForStoreMove(ctx.timer, ctx.timerId, ctx.indexField, ctx.currentState)

            if (ctx.timer.status > TIMERPRODUCT_STATUS.EXPIRED) {
                return this.dispatchStoreMoveTimer(ctx, 'standard')
            }

            return this.handleExpiredTimerMove(ctx)
        },
        // MOVE TIMER TO NEXT STATE
        async moveTimerNextState(params) {
            const ctx = this.buildMoveTimerContext(params)

            if (!ctx.canProceed) {
                return this.rejectMove(ctx)
            }

            if (!ctx.nextState) {
                return this.rejectMove(ctx, { respectSkipPopup: true })
            }

            const relationResult = this.evaluateMoveRelations(ctx)
            if (relationResult.earlyPromise) {
                return relationResult.earlyPromise
            }

            if (relationResult.relationMetadataPromise) {
                return relationResult.relationMetadataPromise.then(() => this.executeNoRelationMove(ctx))
            }

            return this.executeNoRelationMove(ctx)
        },
        confirmPrintTimer() {
            if (this.batchPrintConfirmInFlight) {
                return
            }
            if (this.intervalToPrintTimer) {
                clearInterval(this.intervalToPrintTimer)
            }
            const batchIds = this.pendingBatchPrintTimerIds
            if (batchIds && batchIds.length > 0) {
                this.batchPrintConfirmInFlight = true
                const afterMove = this.pendingPrintIsAfterMove
                this.pendingPrintIsAfterMove = false
                this.pendingBatchPrintTimerIds = null
                const self = this
                Promise.all(batchIds.map((id) => self.printLabel(id, afterMove))).finally(() => {
                    self.batchPrintConfirmInFlight = false
                    self.closePopupToPrintTimer()
                })
                return
            }
            if (this.newTimerToPrint === false || this.newTimerToPrint === null || this.newTimerToPrint === undefined) {
                this.closePopupToPrintTimer()
                return
            }
            const afterMove = this.pendingPrintIsAfterMove
            this.pendingPrintIsAfterMove = false
            this.printLabel(this.newTimerToPrint, afterMove)
            this.closePopupToPrintTimer()
        },
        closePopupToPrintTimer() {
            this.isPopupToPrintTimerOpen = false
            this.pendingPrintIsAfterMove = false
            this.pendingBatchPrintTimerIds = null
            this.batchPrintConfirmInFlight = false
            if (this.intervalToPrintTimer) {
                clearInterval(this.intervalToPrintTimer)
            }
        },
        deleteTimer(timerId, skipLocalStorage = false, isLastTimer = false, skipClosePopup = false, skipValidation = false) {
            var self = this
            const timers = this.$store.getters['timerproduct/getTimers']
            let timer = timers[timerId]

            // Validar que el timer existe antes de continuar
            if (!timer) {
                // Si skipValidation es true, solo retornar sin error (ya se validó antes)
                if (skipValidation) {
                    return Promise.resolve()
                }

                // Si es parte de una eliminación múltiple, solo rechazar esta promesa
                if (skipLocalStorage) {
                    return Promise.resolve() // Continuar con los demás timers
                }

                // Si es individual, mostrar error al usuario
                this.$snackbar.error({
                    message: this.$t('timers.timer_not_found'),
                    closeable: true
                })
                return Promise.reject(new Error(`Timer ${timerId} no existe en el store`))
            }

            timer.isLoading = true

            // Usar helper para obtener cantidad válida (maneja NaN, null, undefined y strings vacíos)
            const validQuantity = this.getValidQuantity(timer)
            const validDeletedCount = parseInt(this.deletedTimerCount)

            // Determinar si es eliminación parcial (updateAvaibles) o completa
            let updateAvaibles = false

            // Multistatus: siempre eliminar el timer completo vía removes (deleteTimers), no reducir quantity_avaibles con /update
            if (!this.isMultiStatusFlagEnabled(timer)) {
                // Si no hay cantidad válida o deletedCount es inválido, tratar como eliminación completa
                if (validQuantity !== null && !isNaN(validDeletedCount)) {
                    // Comparar cantidad válida con deletedCount para determinar si es eliminación parcial o completa
                    updateAvaibles = validQuantity !== validDeletedCount
                }
            }

            if (updateAvaibles) {
                // Usar helper para obtener cantidad válida (ya validada arriba)
                const validQuantityAvaibles = validQuantity || 0
                // validDeletedCount ya está calculado arriba, reutilizarlo
                const safeDeletedCount = !isNaN(validDeletedCount) ? validDeletedCount : 0

                // Guardar información del timer y cantidad a restaurar para el caso de update
                // Leer array existente para evitar race conditions en eliminaciones rápidas
                const existingTimersUpdate = JSON.parse(localStorage.getItem('deletedTimersUpdate') || '[]')
                const timerInfo = {
                    id: timerId,
                    originalQuantity: validQuantityAvaibles, // Cantidad ANTES de eliminar (validada)
                    deletedCount: safeDeletedCount
                }
                // Evitar duplicados verificando si el timer ya está en la lista
                if (!existingTimersUpdate.find((t) => t && t.id === timerId)) {
                    existingTimersUpdate.push(timerInfo)
                    localStorage.setItem('deletedTimersUpdate', JSON.stringify(existingTimersUpdate))
                }

                // Calcular nueva cantidad asegurándose de que no sea NaN
                const newQuantityAvaibles = Math.max(0, validQuantityAvaibles - safeDeletedCount)

                return self.$store.dispatch('timerproduct/updateTimer', { id: timerId, data: { quantity_avaibles: newQuantityAvaibles } }).then(() => {
                    // Solo mostrar snackbar en el último timer si es múltiple, o siempre si es individual
                    if (!skipLocalStorage || isLastTimer) {
                        const { message, isMixedTypes } = self.getDeleteMessage(skipLocalStorage)

                        self.$snackbar.error({
                            closeable: true,
                            message: message,
                            customClass: 'delete-timer-button',
                            actionType: 'button',
                            textButton: self.$t('popup.sign.text_undo'),
                            duration: 5000,
                            action: () => (isMixedTypes ? self.restoreMixedTimers() : self.restoreUpdateTimers()),
                            onClose: () => self.handleDeleteUpdateTimer()
                        })
                    }
                    if (!skipLocalStorage && !skipClosePopup) {
                        self.closePopupTimer()
                    }
                })
            } else {
                // Guardar timer en deletedTimersFullDelete para eliminación completa
                const timerToDelete = timers[timerId]

                // Leer array existente para evitar race conditions en eliminaciones rápidas
                const existingFullDelete = JSON.parse(localStorage.getItem('deletedTimersFullDelete') || '[]')
                // Evitar duplicados verificando si el timer ya está en la lista
                if (!existingFullDelete.find((t) => t && t.id === timerToDelete.id)) {
                    existingFullDelete.push(timerToDelete)
                    localStorage.setItem('deletedTimersFullDelete', JSON.stringify(existingFullDelete))
                }

                // Eliminar temporalmente del store (como funcionaba antes)
                return self.$store.dispatch('timerproduct/deleteTimerTemporarily', { timerId }).then(() => {
                    // Solo mostrar snackbar en el último timer si es múltiple, o siempre si es individual
                    if (!skipLocalStorage) {
                        self.$snackbar.error({
                            closeable: true,
                            message: self.$tc('timers.remove_timers', 1, { timers: 1 }),
                            customClass: 'delete-timer-button',
                            actionType: 'button',
                            textButton: self.$t('popup.sign.text_undo'),
                            duration: 5000,
                            action: () => self.restoreTimers(),
                            onClose: () => self.handleSnackbarClose()
                        })
                        if (!skipClosePopup) {
                            self.closePopupTimer()
                        }
                    } else if (isLastTimer) {
                        // Para múltiples timers, mostrar snackbar solo al final
                        const { message, isMixedTypes } = self.getDeleteMessage(skipLocalStorage)

                        self.$snackbar.error({
                            closeable: true,
                            message: message,
                            customClass: 'delete-timer-button',
                            actionType: 'button',
                            textButton: self.$t('popup.sign.text_undo'),
                            duration: 5000,
                            action: () => (isMixedTypes ? self.restoreMixedTimers() : self.restoreTimers()),
                            onClose: () => self.handleSnackbarClose()
                        })
                    }
                })
            }
        },
        handleDeleteTimer(timerId) {
            if (!this.isTimersRestore) {
                const timers = this.$store.getters['timerproduct/getTimersDeletes']
                var self = this

                if (timers[timerId] && timers[timerId].data.timers_relations && timers[timerId].data.timers_relations.length > 0) {
                    const firstRelation = JSON.parse(timers[timerId].data.timers_relations)[0]
                    const timersNow = this.$store.getters['timerproduct/getTimers']
                    this.$store.dispatch('timerproduct/deleteTimer', { id: timerId }).then(() => {
                        localStorage.removeItem('deletedTimersFullDelete')
                        localStorage.removeItem('deletedTimersUpdate')
                        this.isTimersRestore = false
                        self.closePopupTimer()
                        self.$store
                            .dispatch('timerproduct/updateTimer', {
                                id: firstRelation.id_timer_rel,
                                verify_relations: true,
                                data: { quantity_avaibles: timersNow[firstRelation.id_timer_rel].data.quantity_avaibles }
                            })
                            .then(() => {})
                    })
                } else {
                    const timersNow = this.$store.getters['timerproduct/getTimers']
                    this.$store.dispatch('timerproduct/deleteTimer', { id: timerId }).then(() => {
                        localStorage.removeItem('deletedTimersFullDelete')
                        localStorage.removeItem('deletedTimersUpdate')
                        this.isTimersRestore = false
                        self.closePopupTimer()
                        self.$store
                            .dispatch('timerproduct/updateTimer', {
                                id: timerId,
                                verify_relations: true,
                                data: { quantity_avaibles: 0 }
                            })
                            .then(() => {})
                    })
                }
            }
        },
        async handleDeleteUpdateTimer() {
            if (!this.isTimersRestore) {
                const savedTimersUpdate = JSON.parse(localStorage.getItem('deletedTimersUpdate') || '[]')

                if (savedTimersUpdate.length > 0) {
                    // Los timers ya están actualizados con cantidades reducidas, solo limpiamos localStorage
                    localStorage.removeItem('deletedTimersUpdate')
                    localStorage.removeItem('deletedTimersFullDelete')
                    this.isTimersRestore = false
                    this.closePopupTimer()
                }
            }
        },
        async restoreUpdateTimers() {
            try {
                this.isTimersRestore = true
                const savedTimersUpdate = JSON.parse(localStorage.getItem('deletedTimersUpdate'))

                if (savedTimersUpdate && savedTimersUpdate.length > 0) {
                    // Guardar las características del grupo ANTES de restaurar si el modal está abierto
                    // PRIMERO: Usar las características ya guardadas si existen (más confiable)
                    if (this.popupGroupTimerOpen && !this.savedGroupCharacteristics) {
                        if (this.groupTimers.length > 0 && this.groupTimers[0]) {
                            this.savedGroupCharacteristics = this.buildGroupCharacteristics(this.groupTimers[0])
                        } else if (savedTimersUpdate.length > 0 && savedTimersUpdate[0]) {
                            // Si no hay groupTimers, usar el primer timer que se va a restaurar
                            const timers = this.$store.getters['timerproduct/getTimers']
                            const timerToRestore = timers[savedTimersUpdate[0].id]
                            if (timerToRestore) {
                                this.savedGroupCharacteristics = this.buildGroupCharacteristics(timerToRestore)
                            }
                        }
                    }

                    // Restaurar todos los timers a sus cantidades originales (antes de la eliminación)
                    const restorePromises = savedTimersUpdate.map((timerInfo) => {
                        // originalQuantity ya contiene la cantidad antes de eliminar, no necesitamos sumar
                        return this.$store.dispatch('timerproduct/updateTimer', {
                            id: timerInfo.id,
                            data: { quantity_avaibles: timerInfo.originalQuantity }
                        })
                    })

                    await Promise.all(restorePromises)

                    // Esperar más tiempo para asegurar que los timers se actualicen completamente
                    await this.$nextTick()
                    await this.$nextTick()
                    await new Promise((resolve) => setTimeout(resolve, 400))

                    // Actualizar el grupo modal si está abierto
                    await this.updateGroupModalAfterRestore()

                    localStorage.removeItem('deletedTimersUpdate')
                    localStorage.removeItem('deletedTimersFullDelete')
                    this.$snackbar.close()

                    this.$snackbar.progress({
                        message: this.$t('timers.restore_success'),
                        closeable: true
                    })
                }
            } catch (error) {
                this.$snackbar.error({
                    message: this.$t('timers.restore_error'),
                    closeable: true
                })
            } finally {
                this.isTimersRestore = false
            }
        },
        async restoreMixedTimers() {
            try {
                this.isTimersRestore = true
                const savedTimersUpdate = JSON.parse(localStorage.getItem('deletedTimersUpdate') || '[]')
                const savedTimersFullDelete = JSON.parse(localStorage.getItem('deletedTimersFullDelete') || '[]')

                const allPromises = []

                // Restaurar timers con cantidad actualizada (updateAvaibles)
                if (savedTimersUpdate.length > 0) {
                    const updatePromises = savedTimersUpdate.map((timerInfo) => {
                        return this.$store.dispatch('timerproduct/updateTimer', {
                            id: timerInfo.id,
                            data: { quantity_avaibles: timerInfo.originalQuantity }
                        })
                    })
                    allPromises.push(...updatePromises)
                }

                // Restaurar SOLO timers completamente eliminados (que están en deletedTimers del store)
                if (savedTimersFullDelete.length > 0) {
                    const chunkedRestoreTimers = this.chunkArray(savedTimersFullDelete, 20)
                    const deletePromises = chunkedRestoreTimers.map((chunk) => {
                        return this.$store.dispatch('timerproduct/restoreTimers', { timers: chunk })
                    })
                    allPromises.push(...deletePromises)
                }

                // Esperar a que todas las restauraciones completen
                await Promise.all(allPromises)

                // Guardar las características del grupo ANTES de restaurar si el modal está abierto
                let savedGroupCharacteristics = null
                if (this.popupGroupTimerOpen && this.groupTimers.length > 0 && this.groupTimers[0]) {
                    savedGroupCharacteristics = this.buildGroupCharacteristics(this.groupTimers[0])
                } else if (this.popupGroupTimerOpen && savedTimersFullDelete.length > 0 && savedTimersFullDelete[0]) {
                    // Si no hay groupTimers pero hay timers guardados, usar el primer timer guardado
                    const firstSavedTimer = savedTimersFullDelete[0]
                    if (firstSavedTimer.reference_id) {
                        savedGroupCharacteristics = this.buildGroupCharacteristics(firstSavedTimer)
                    }
                }

                // Si se restauraron timers completamente eliminados, recargar timers para asegurar que el grupo se recalcule
                if (savedTimersFullDelete.length > 0) {
                    await this.$store.dispatch('timerproduct/loadTimers')
                    // Esperar a que los computed se actualicen después de cargar
                    await this.$nextTick()
                    await this.$nextTick()
                    await new Promise((resolve) => setTimeout(resolve, 800))
                }

                // Restaurar las características del grupo si se guardaron
                if (savedGroupCharacteristics && this.popupGroupTimerOpen) {
                    // NO crear objetos temporales sin id - updateGroupModalAfterRestore puede trabajar sin groupTimers
                    // Las características guardadas son suficientes para buscar los timers restaurados
                }

                localStorage.removeItem('deletedTimersUpdate')
                localStorage.removeItem('deletedTimersFullDelete')

                // Actualizar el grupo modal después de que todo esté actualizado
                await this.updateGroupModalAfterRestore()

                this.$snackbar.close()

                this.$snackbar.progress({
                    message: this.$t('timers.restore_success'),
                    closeable: true
                })
            } catch (error) {
                this.$snackbar.error({
                    message: this.$t('timers.restore_error'),
                    closeable: true
                })
            } finally {
                this.isTimersRestore = false
            }
        },
        checkPrinter(bValidateAndroid, bValidateWindows) {
            var bValidateAndroid = typeof bValidateAndroid !== 'undefined' ? bValidateAndroid : true
            var bValidateWindows = typeof bValidateWindows !== 'undefined' ? bValidateWindows : true

            var self = this
            var error = []

            var current_printer = this.$store.getters['printer/getCurrentPrinter']
            var config = null
            if (!current_printer || !this.$store.getters['printer/getPrinterConfig'](current_printer)) {
                var printersConfig = this.$store.getters['printer/getPrinterConfig']()
                for (var p in printersConfig) {
                    if (config == null) {
                        var pc = printersConfig[p]
                        // if ((pc.platform == 'android' && this.$store.getters.getIsApp) || (pc.platform == 'windows' && !this.$store.getters.getIsApp)) {
                        if ((pc.platform == 'windows' && !this.$store.getters.getIsApp) || pc.mode == 'WIFI' || pc.print_mode == 'wifi' || (this.$store.getters.getIsApp && pc.platform == cordova.platformId)) {
                            config = Object.assign({}, pc)
                            this.$store.dispatch('printer/setCurrentPrinter', pc.id)
                        }
                    }
                }
            } else {
                config = Object.assign({}, this.$store.getters['printer/getPrinterConfig'](current_printer))
            }
            var bCanPrintWindows = false
            if (config) {
                var printer = this.$store.getters['printer/getModels'](config.model)
                if (printer) {
                    var templates = this.$store.getters['printer/getTemplatesByPrinterModel'](printer.id)
                    for (var k in templates) {
                        var label = self.$store.getters['printer/getLabels'](templates[k].label_id)
                        if (!bCanPrintWindows && typeof label.tpl_file_windows !== 'undefined' && label.tpl_file_windows != null) {
                            bCanPrintWindows = true
                        }
                    }
                    if (self.$store.getters.getIsApp || bCanPrintWindows) {
                        if ((typeof printer.name === 'undefined' || !printer.name) && (typeof printer.mode === 'undefined' || !printer.mode) && self.$store.getters.getIsApp) {
                            error.push(true)
                        } else if (!bCanPrintWindows && !self.$store.getters.getIsApp) {
                            error.push(true)
                        }
                        //TODO VALIDATE HOW DETECT IF ALL TEMPLATES ARE LOADED
                        // else if ((typeof auxPrinter.template_loaded === 'undefined' || !auxPrinter.template_loaded) && printer.templates[printer.config.template_id].model.sdk == 'brother' && process.env.VUE_APP_IS_APP == 'TRUE') {
                        //     error.push(true)
                        // }

                        if (error.indexOf(true) != -1) {
                            this.printerConfigured = false
                            // this.cantSelectCategoryPrinterError = true
                            // if (this.getRoleLoggedUser && this.getRoleLoggedUser.level > 1) {
                            //     self.$popup.alert({
                            //         closable: false,
                            //         blocking: false,
                            //         customClass: 'popup-label-admin',
                            //         message: self.$t('label.printer.alert_empty'),
                            //         textSave: self.$t('label.printer.alert_save'),
                            //         callSave: function (response) {
                            //             self.$router.push({
                            //                 name: 'Config',
                            //                 params: { page: 'printer' }
                            //             })
                            //         }
                            //     })
                            // } else {
                            //     self.$popup.alert({
                            //         blocking: false,
                            //         closable: false,
                            //         customClass: 'popup-label',
                            //         message: self.$t('label.printer.alert_role_level_1')
                            //     })
                            // }
                        } else {
                            self.initStatusPrinter(bValidateAndroid, bValidateWindows)
                        }
                    }
                } else {
                    this.printerConfigured = false
                    // this.cantSelectCategoryPrinterError = true
                    // if (this.getRoleLoggedUser && this.getRoleLoggedUser.level > 1) {
                    //     self.$popup.alert({
                    //         closable: false,
                    //         blocking: false,
                    //         customClass: 'popup-label-admin',
                    //         message: self.$t('label.printer.alert_empty'),
                    //         textSave: self.$t('label.printer.alert_save'),
                    //         callSave: function (response) {
                    //             self.$router.push({
                    //                 name: 'Config',
                    //                 params: { page: 'printer' }
                    //             })
                    //         }
                    //     })
                    // } else {
                    //     self.$popup.alert({
                    //         blocking: false,
                    //         closable: false,
                    //         customClass: 'popup-label',
                    //         message: self.$t('label.printer.alert_role_level_1')
                    //     })
                    // }
                }
            } else {
                this.printerConfigured = false
                // this.cantSelectCategoryPrinterError = true
                // if (this.getRoleLoggedUser && this.getRoleLoggedUser.level > 1) {
                //     self.$popup.alert({
                //         closable: false,
                //         blocking: false,
                //         customClass: 'popup-label-admin',
                //         message: self.$t('label.printer.alert_empty'),
                //         textSave: self.$t('label.printer.alert_save'),
                //         callSave: function (response) {
                //             self.$router.push({
                //                 name: 'Config',
                //                 params: { page: 'printer' }
                //             })
                //         }
                //     })
                // } else {
                //     self.$popup.alert({
                //         blocking: false,
                //         closable: false,
                //         customClass: 'popup-label',
                //         message: self.$t('label.printer.alert_role_level_1')
                //     })
                // }
            }
        },
        validatePrinter() {
            if (this.printerError == i18n.t('config.printer.errors.bpac_no_installed')) {
                window.open('https://chrome.google.com/webstore/detail/ilpghlfadkjifilabejhhijpfphfcfhb', '_blank')
            }
            this.initStatusPrinter()
        },
        initStatusPrinter(bLaunchAndroidValidate, bLaunchWindowValidate) {
            var self = this
            var bLaunchAndroid = typeof bLaunchAndroidValidate !== 'undefined' ? bLaunchAndroidValidate : true
            var bLaunchWindow = typeof bLaunchWindowValidate !== 'undefined' ? bLaunchWindowValidate : true
            if (!this.checkingStatusPrinter) {
                if (this.$store.getters.getIsApp && bLaunchAndroid) {
                    // clearInterval(this.iIntervalStatusPrinter)
                    this.$store.dispatch('printer/statusPrinter')
                    var self = this
                    // this.iIntervalStatusPrinter = setInterval(function() {
                    //     self.$store.dispatch('printer/statusPrinter')
                    // }, 60000)
                } else if (!this.$store.getters.getIsApp && bLaunchWindow) {
                    if (!this.isValidatebPac) {
                        return true
                        return self.$store.dispatch('printer/validateBpac')
                    }
                }
            }
        },

        /**
         * Resuelve la plantilla de impresión como en products.vue: plantilla base y,
         * si hace falta, variante por modelo de impresora (evita format=false tras mover timer).
         * Criterio de “plantilla ya válida para la impresora”: label.printer_id vs modelo actual,
         * igual que printer/getTemplates(id, printer_id) (no baseFormat.printer_id).
         * Usa == en ids frente al modelo/padre (API string|number).
         * Bucle igual que products.vue: variable format mutable; la última plantilla que encaja gana.
         */
        resolveFormatForTimerPrint(formatId, currentPrinterConfig) {
            return resolveFormatForPrintUtil(formatId, this.printerStoreAccessors(), currentPrinterConfig)
        },

        printLabel(timerId, bMoveAndPrint = false) {
            var self = this
            const timers = this.$store.getters['timerproduct/getTimers']
            if (timerId === false || timerId === null || timerId === undefined) {
                return Promise.resolve()
            }
            const timer = timers[timerId] || timers[String(timerId)]
            if (!timer) {
                return Promise.resolve()
            }
            let printData = []
            const product = this.$store.getters['timerproduct/getProducts'](timer.reference_id)
            if (!product || !product.states || !product.states[timer.state]) {
                return Promise.resolve()
            }
            const formatId = product.states[timer.state].format
            var current_config = this.$store.getters['printer/getCurrentPrinter']
            var currentPrinterConfig = this.$store.getters['printer/getPrinterConfig'](current_config)
            const format = this.resolveFormatForTimerPrint(formatId, currentPrinterConfig)
            if (!format || !format.id) {
                this.$snackbar.error({
                    closeable: true,
                    message: this.$t('config.printer.windows.errorTplPath')
                })
                return Promise.resolve()
            }
            let timerData = timer.data
            if (typeof timerData === 'string') {
                try {
                    timerData = JSON.parse(timerData)
                } catch (e) {
                    this.$snackbar.error({
                        closeable: true,
                        message: this.$t('config.printer.error_print_default')
                    })
                    return Promise.resolve()
                }
            }
            if(!timerData.is_timer || timerData.is_timer.trim() == '') {
                timerData.is_timer = '●'
            }

            var formatValues = format ? JSON.parse(format.data) : []
            var newPreviewStructure = format.realistic_preview ? JSON.parse(format.realistic_preview) : false

            let dates = ['print_date', 'date', 'prep_date', 'caducidad']

            for (var field in formatValues) {
                var value = formatValues[field]

                if (value) {
                    let aux = value

                    let start = aux.indexOf('[') > -1 ? aux.indexOf('[') : aux.indexOf('{')
                    start++
                    let end = aux.indexOf(']') > -1 ? aux.indexOf(']') : aux.indexOf('}')
                    let keyValue = aux.substring(start, end)
                    let oldKeyValue = aux.substring(start, end)

                    if (dates.includes(keyValue)) {
                        let auxMoment = moment(timerData[keyValue + '_timestamp'] * 1000)
                        timerData[keyValue + '_d1'] = auxMoment.isoWeekday() === 1 ? 'x' : ' '
                        timerData[keyValue + '_d2'] = auxMoment.isoWeekday() === 2 ? 'x' : ' '
                        timerData[keyValue + '_d3'] = auxMoment.isoWeekday() === 3 ? 'x' : ' '
                        timerData[keyValue + '_d4'] = auxMoment.isoWeekday() === 4 ? 'x' : ' '
                        timerData[keyValue + '_d5'] = auxMoment.isoWeekday() === 5 ? 'x' : ' '
                        timerData[keyValue + '_d6'] = auxMoment.isoWeekday() === 6 ? 'x' : ' '
                        timerData[keyValue + '_d7'] = auxMoment.isoWeekday() === 7 ? 'x' : ' '
                    }

                    while (keyValue) {
                        keyValue = keyValue.replace('[', '').replace(']', '').replace('{', '').replace('}', '')
                        aux = aux.replace('[', '').replace(']', '').replace('{', '').replace('}', '')

                        const fieldVal = timerData[keyValue]
                        aux = aux.replace(keyValue, fieldVal !== undefined && fieldVal !== null ? String(fieldVal) : '')

                        if (newPreviewStructure) {
                            newPreviewStructure.fields.forEach((el) => {
                                if (el.f_id && el.f_id == field) {
                                    if (el.format && el.type === 'barcode') {
                                        aux = moment(aux, 'DD/MM/YYYY HH:mm').format(el.format)
                                    }
                                } else if (!el.f_id && el.value == value && el.format && el.type === 'barcode') {
                                    aux = moment(aux, 'DD/MM/YYYY HH:mm').format(el.format)
                                }
                            })
                        }

                        if (['print_date', 'print_date_time', 'print_date_day'].includes(keyValue) && false) {
                            aux += ' *'
                        }

                        start = aux.indexOf('[') > -1 ? aux.indexOf('[') : aux.indexOf('{')
                        start++
                        end = aux.indexOf(']') > -1 ? aux.indexOf(']') : aux.indexOf('}')
                        keyValue = aux.substring(start, end)
                        oldKeyValue = aux.substring(start, end)
                    }
                    const previewField = newPreviewStructure && newPreviewStructure.fields.find(el => el.f_id ? el.f_id == field : el.value == value)
                    if (previewField && previewField.format && previewField.type !== 'barcode') {
                        aux = formatPrintedDateFromStore(aux, previewField.format)
                    }
                    var data = aux
                    data = data.trim() === '' ? ' ' : data
                    printData.push({ k: field, v: data })
                } else {
                    printData.push({ k: field, v: ' ' })
                }
            }

            const numCopiesRaw = bMoveAndPrint ? timer.quantity_move : this.printedTimerCount
            const num_copies = Math.max(1, parseInt(numCopiesRaw, 10) || 1)

            self.$overlay.loading()
            return this.$store
                .dispatch('printer/printLabel', {
                    printData: printData,
                    num_copies,
                    context: {
                        config: current_config,
                        printer: currentPrinterConfig ? currentPrinterConfig.model : undefined,
                        template: format.id,
                        label: format.label_id
                    }
                })
                .then(function () {
                    if (self.statusPrinter) {
                        let msg = i18n.tc('config.printer.success_window_print', 1)
                        msg = msg.replace('[product]', product.name)
                        self.$snackbar.progress({
                            closeable: true,
                            message: msg
                        })
                        self.$overlay.hide()
                    } else {
                        let msg = timerPrintError(self.errorPrinter, product.name)
                        self.$snackbar.error({
                            closeable: true,
                            message: msg
                        })
                        self.$overlay.hide()
                    }
                })
                .catch(function (error) {
                    const specific = gprinterStatusText(error, function (key, params) {
                        return i18n.t(key, params)
                    })
                    let msg = specific || timerPrintError(self.errorPrinter, product.name)
                    self.$snackbar.error({
                        closeable: true,
                        message: msg
                    })
                    self.$overlay.hide()
                })
        },
        createTimerInit(product) {
            // var self = this
            // self.$store.dispatch('timerproduct/addTimerLocal', product)
            this.$overlay.loading()
        },
        createTimerEnd() {
            this.$overlay.hide()
        },
        addTimerSelected(info) {
            this.$store.commit('timerproduct/toggleTimerSelected', { timerId: info.timerId })

            this.verifyAllSelected(info.columnId)
        },
        verifyAllSelected(columnId) {
            const timerByColum = this.$store.getters['timerproduct/getTimersFilterByCategory'](columnId)
            const timerByColumSelected = this.$store.getters['timerproduct/getTimersFilterByCategorySelected'](columnId)

            if (timerByColum.length === timerByColumSelected.length) {
                const columnIndex = this.columns.findIndex((column) => column.id === columnId)
                if (columnIndex !== -1) {
                    this.columns[columnIndex].selectAll = true
                }
            } else {
                const columnIndex = this.columns.findIndex((column) => column.id === columnId)
                if (columnIndex !== -1) {
                    this.columns[columnIndex].selectAll = false
                }
            }
        },
        handleSelectAllTimers(data) {
            const timerByColum = this.$store.getters['timerproduct/getTimersFilterByCategory'](data.column.id)

            timerByColum.forEach((timer) => {
                if (data.deselect) {
                    this.$store.commit('timerproduct/toggleTimerSelected', { timerId: timer.id, forceFalse: true })
                    this.verifyAllSelected(data.column.id)
                } else {
                    this.$store.commit('timerproduct/toggleTimerSelected', { timerId: timer.id, forceTrue: true })
                    this.verifyAllSelected(data.column.id)
                }
            })
        },
        async handleDeleteSelectAll() {
            const timers = this.$store.getters['timerproduct/getTimers']

            // Obtener todos los timers seleccionados
            const timersSelect = Object.entries(timers).reduce((ids, [key, timer]) => {
                if (timer.isSelected) {
                    ids.push(timers[timer.id])
                }
                return ids
            }, [])

            if (timersSelect.length === 0) {
                return
            }

            // Para cada timer seleccionado, obtener su grupo completo si existe
            const allTimersToDelete = []
            const processedGroups = new Set()

            timersSelect.forEach((timer) => {
                // Buscar el grupo al que pertenece este timer
                const group = this.findTimerGroup(timer.id)

                if (group && group.groupedTimers && group.groupedTimers.length > 1) {
                    // Si el grupo ya fue procesado, saltarlo
                    if (processedGroups.has(group.groupKey)) {
                        return
                    }

                    // Marcar el grupo como procesado
                    processedGroups.add(group.groupKey)

                    // Agregar TODOS los timers del grupo, no solo los seleccionados
                    group.groupedTimers.forEach((timerFromGroup) => {
                        const timerFromStore = timers[timerFromGroup.id]
                        if (timerFromStore && !allTimersToDelete.find((t) => t.id === timerFromGroup.id)) {
                            allTimersToDelete.push(timerFromStore)
                        }
                    })
                } else {
                    // Si no pertenece a un grupo, agregarlo individualmente
                    if (!allTimersToDelete.find((t) => t.id === timer.id)) {
                        allTimersToDelete.push(timer)
                    }
                }
            })

            if (allTimersToDelete.length === 0) {
                return
            }

            // Guardar en localStorage para poder restaurar
            localStorage.setItem('deletedTimersFullDelete', JSON.stringify(allTimersToDelete))

            // Marcar como loading
            allTimersToDelete.forEach((timer) => {
                if (timers[timer.id]) {
                    timers[timer.id].isLoading = true
                }
            })

            try {
                // Eliminar temporalmente del store (como funcionaba antes)
                const chunkedTimers = this.chunkArray(allTimersToDelete, 20)
                const promises = chunkedTimers.map((chunkTimer) => {
                    return this.$store.dispatch('timerproduct/deleteTimersTemporarily', { timers: chunkTimer })
                })

                await Promise.all(promises)

                this.$snackbar.error({
                    closeable: true,
                    message: this.$tc('timers.remove_timers', allTimersToDelete.length, { timers: allTimersToDelete.length }),
                    customClass: 'delete-timer-button',
                    actionType: 'button',
                    textButton: this.$t('popup.sign.text_undo'),
                    duration: 5000,
                    action: () => this.restoreTimers(),
                    onClose: () => this.handleSnackbarClose()
                })
                this.closePopupTimer()
            } catch (error) {
                localStorage.removeItem('deletedTimersFullDelete')
                this.$snackbar.error({
                    message: this.$t('timers.delete_error'),
                    closeable: true
                })
            }
        },
        async handleSnackbarClose() {
            if (!this.isTimersRestore) {
                // Eliminar permanentemente del backend los timers que fueron eliminados temporalmente
                const deletedTimersFullDelete = JSON.parse(localStorage.getItem('deletedTimersFullDelete') || '[]')

                // Verificar que todos los timers tengan IDs válidos
                const validTimers = deletedTimersFullDelete && deletedTimersFullDelete.length > 0 ? deletedTimersFullDelete.filter((timer) => timer && timer.id) : []

                let shouldCleanLocalStorage = false

                if (validTimers.length > 0) {
                    const chunkedDeleteTimers = this.chunkArray(validTimers, 20)
                    const allDeletedIds = validTimers.map((timer) => timer.id)

                    const deletePromises = chunkedDeleteTimers.map((chunk) => {
                        return this.$store.dispatch('timerproduct/deleteTimers', { timers: chunk, syncParentLetters: false })
                    })

                    try {
                        const results = await Promise.all(deletePromises)
                        // Verificar que todas las eliminaciones fueron exitosas
                        const allSuccessful = results.every((result) => result === true)

                        if (allSuccessful) {
                            await this.$store.dispatch('timerproduct/syncOrphanedParentLettersAfterBulkDelete', {
                                timers: validTimers,
                                deletedIds: allDeletedIds
                            })
                            // Solo limpiar localStorage si todas las eliminaciones fueron exitosas
                            shouldCleanLocalStorage = true
                        } else {
                            // Si alguna falló, mantener localStorage para permitir reintento
                            logError('Error: algunas eliminaciones del backend fallaron. Los timers permanecen en localStorage para reintento.')
                        }
                    } catch (error) {
                        // En caso de error, mantener localStorage para permitir reintento
                        logError('Error al eliminar permanentemente del backend:', error)
                        // localStorage se mantiene para permitir reintento manual o automático
                    }
                } else {
                    // No hay timers válidos o el array está vacío, limpiar localStorage
                    shouldCleanLocalStorage = true
                }

                // Limpiar localStorage si corresponde (consolidado para evitar duplicación)
                if (shouldCleanLocalStorage) {
                    localStorage.removeItem('deletedTimersFullDelete')
                    localStorage.removeItem('deletedTimersUpdate')
                }

                this.isTimersRestore = false
            }
        },
        restoreTimers: async function () {
            try {
                this.isTimersRestore = true
                const savedTimers = JSON.parse(localStorage.getItem('deletedTimersFullDelete') || '[]')
                if (savedTimers && savedTimers.length > 0) {
                    // Guardar las características del grupo ANTES de restaurar si el modal está abierto
                    // PRIMERO: Usar las características ya guardadas si existen (más confiable)
                    let savedGroupCharacteristics = null
                    if (this.popupGroupTimerOpen && this.savedGroupCharacteristics) {
                        savedGroupCharacteristics = this.savedGroupCharacteristics
                    } else if (this.popupGroupTimerOpen && this.groupTimers.length > 0 && this.groupTimers[0]) {
                        savedGroupCharacteristics = this.buildGroupCharacteristics(this.groupTimers[0])
                        // Guardar en this.savedGroupCharacteristics para que updateGroupModalAfterRestore las use
                        this.savedGroupCharacteristics = savedGroupCharacteristics
                    } else if (this.popupGroupTimerOpen && savedTimers.length > 0 && savedTimers[0]) {
                        // Si no hay groupTimers pero hay timers guardados, usar el primer timer guardado
                        const firstSavedTimer = savedTimers[0]
                        if (firstSavedTimer.reference_id) {
                            savedGroupCharacteristics = this.buildGroupCharacteristics(firstSavedTimer)
                            // Guardar en this.savedGroupCharacteristics para que updateGroupModalAfterRestore las use
                            this.savedGroupCharacteristics = savedGroupCharacteristics
                        }
                    }

                    const chunkedRestoreTimers = this.chunkArray(savedTimers, 20)

                    const restorePromises = chunkedRestoreTimers.map((chunk) => {
                        return this.$store.dispatch('timerproduct/restoreTimers', { timers: chunk })
                    })

                    await Promise.all(restorePromises)

                    // Cargar timers primero para asegurar que el store esté actualizado
                    await this.$store.dispatch('timerproduct/loadTimers')

                    // Esperar más tiempo para asegurar que los timers se carguen completamente
                    await this.$nextTick()
                    await this.$nextTick()
                    await new Promise((resolve) => setTimeout(resolve, 800))

                    // Asegurar que las características se mantengan guardadas para updateGroupModalAfterRestore
                    if (savedGroupCharacteristics && this.popupGroupTimerOpen) {
                        // Asegurar que this.savedGroupCharacteristics esté establecido
                        if (!this.savedGroupCharacteristics) {
                            this.savedGroupCharacteristics = savedGroupCharacteristics
                        }
                    }

                    localStorage.removeItem('deletedTimersFullDelete')
                    localStorage.removeItem('deletedTimersUpdate')

                    // Actualizar el grupo modal después de cargar los timers
                    await this.updateGroupModalAfterRestore()

                    this.$snackbar.close()
                    this.$snackbar.progress({
                        message: this.$t('timers.restore_success'),
                        closeable: true
                    })
                }
            } catch (error) {
                this.$snackbar.error({
                    message: this.$t('timers.restore_error'),
                    closeable: true
                })
            } finally {
                this.isTimersRestore = false
            }
        },
        chunkArray(array, chunkSize) {
            return Array.from({ length: Math.ceil(array.length / chunkSize) }, (_, i) => array.slice(i * chunkSize, (i + 1) * chunkSize))
        },

        // ========== Métodos para el Modal de Grupo de Timers ==========

        /**
         * Busca el grupo visual al que pertenece un timer basado en columnTimers
         * @returns {Object|null} El grupo que contiene el timer o null si no está en un grupo
         */
        findTimerGroup(timerId) {
            // Buscar en columnTimers (agrupamiento visual por producto + estado + caducidad)
            // Usar comparación no estricta para manejar IDs como string o number
            for (const columnId in this.columnTimers) {
                const columnGroups = this.columnTimers[columnId]
                if (columnGroups && columnGroups.length > 0) {
                    for (const group of columnGroups) {
                        // Solo considerar grupos con más de 1 timer
                        if (group.groupedTimers && group.groupedTimers.length > 1) {
                            // Verificar si el timer es el principal del grupo
                            // eslint-disable-next-line eqeqeq
                            if (group.id == timerId) {
                                return group
                            }
                            // Verificar si el timer está en los groupedTimers de este grupo
                            // eslint-disable-next-line eqeqeq
                            const found = group.groupedTimers.find((t) => t.id == timerId)
                            if (found) {
                                return group
                            }
                        }
                    }
                }
            }
            return null
        },

        /**
         * Verifica si un timer pertenece a un grupo visual (tiene más de 1 timer agrupado)
         */
        isTimerInGroup(timerId) {
            return this.findTimerGroup(timerId) !== null
        },

        /**
         * Abre el modal de grupo para un timer específico
         */
        showPopupGroupTimer(timerId) {
            const group = this.findTimerGroup(timerId)
            if (!group || !group.groupedTimers) return

            // DESELECCIONAR TODOS LOS TIMERS ANTES DE ABRIR EL MODAL
            const timers = this.$store.getters['timerproduct/getTimers']
            Object.keys(timers).forEach((id) => {
                if (timers[id].isSelected) {
                    this.$store.commit('timerproduct/toggleTimerSelected', { timerId: id, forceFalse: true })
                }
            })

            // Desactivar el modo de selección múltiple
            this.clickEnabledMulti = false

            // Resetear el estado selectAll de todas las columnas
            this.columns.forEach((column) => {
                column.selectAll = false
            })

            // Obtener todos los timers del grupo visual
            this.groupTimers = group.groupedTimers

            // Guardar las características del grupo para usar después cuando se restaure
            if (this.groupTimers.length > 0 && this.groupTimers[0]) {
                this.savedGroupCharacteristics = this.buildGroupCharacteristics(this.groupTimers[0])
            }

            // NO seleccionar ningún timer - dejar que el usuario seleccione manualmente
            // NO preparar preview ni opciones - mostrar el mensaje de "Selecciona el producto"
            this.resetGroupSelectionState()

            this.popupGroupTimerOpen = true
        },

        /**
         * Ajusta los campos de producto y package en el preview
         * Establece producto en 70% y package en 30%, eliminando campos vacíos intermedios
         */
        adjustProductPackageFields(newPreviewStructure, product, data) {
            try {
                if (!newPreviewStructure || !newPreviewStructure.fields || !Array.isArray(newPreviewStructure.fields)) {
                    return
                }

                const productName = product ? product.name : data && data.product ? data.product : ''
                let productFieldIndex = -1
                let packageFieldIndex = -1

                // Buscar campos de producto y package
                newPreviewStructure.fields.forEach((el, index) => {
                    if (!el) return

                    const fieldValue = (el.value || '').trim()

                    // Detectar campo de producto por contenido o por template
                    if (productName && fieldValue === productName && productFieldIndex === -1) {
                        productFieldIndex = index
                    } else if (el.f_id && productFieldIndex === -1) {
                        // Buscar en el template si existe
                        const template = String(el.f_id)
                        if (template && (template.includes('[product]') || template.includes('{product}') || template.includes('[name]') || template.includes('{name}'))) {
                            productFieldIndex = index
                        }
                    }

                    // Detectar campo de package por patrón o template
                    if (packageFieldIndex === -1 && /\d+\s*(KG|G|kg|g|L|l|ML|ml)/i.test(fieldValue)) {
                        packageFieldIndex = index
                    } else if (el.f_id && packageFieldIndex === -1) {
                        const template = String(el.f_id)
                        if (template && (template.includes('[package]') || template.includes('{package}'))) {
                            packageFieldIndex = index
                        }
                    }
                })

                // Si no encontramos por contenido, buscar por width
                if (productFieldIndex === -1) {
                    newPreviewStructure.fields.forEach((el, index) => {
                        if (!el) return
                        const fieldWidth = el.width || 0
                        if (fieldWidth >= 65 && fieldWidth <= 75 && (packageFieldIndex === -1 || index < packageFieldIndex)) {
                            productFieldIndex = index
                        }
                    })
                }

                // Combinar producto y package en un solo campo sin espacio, con package en negrilla
                // Verificar que los índices sean válidos y diferentes para evitar corrupción de campos
                if (productFieldIndex >= 0 && packageFieldIndex >= 0 && productFieldIndex < newPreviewStructure.fields.length && packageFieldIndex < newPreviewStructure.fields.length && productFieldIndex !== packageFieldIndex) {
                    const productField = newPreviewStructure.fields[productFieldIndex]
                    const packageField = newPreviewStructure.fields[packageFieldIndex]

                    if (productField && packageField) {
                        const productValue = (productField.value || '').trim()
                        const packageValue = (packageField.value || '').trim()

                        if (productValue && packageValue) {
                            // Combinar valores: producto + espacio + package ambos con los mismos estilos
                            const commonStyles = 'font-size: 16px; font-style: normal; font-weight: 700; line-height: normal;'
                            productField.value = '<span style="' + commonStyles + '">' + productValue + ' ' + packageValue + '</span>'

                            // Combinar widths: producto (70%) + package (30%) = 100%
                            const productWidth = productField.width || 70
                            const packageWidth = packageField.width || 30

                            // Buscar y sumar width de campo vacío entre producto y package
                            let emptyWidth = 0
                            for (let i = productFieldIndex + 1; i < packageFieldIndex; i++) {
                                if (i < newPreviewStructure.fields.length) {
                                    const fieldBetween = newPreviewStructure.fields[i]
                                    if (fieldBetween) {
                                        const fieldValue = (fieldBetween.value || '').trim()
                                        if (!fieldValue || fieldValue === '' || fieldValue === ' ') {
                                            emptyWidth += fieldBetween.width || 0
                                            // Eliminar este campo vacío
                                            fieldBetween.value = ''
                                            fieldBetween.width = 0
                                            fieldBetween.height = 0
                                        }
                                    }
                                }
                            }

                            // El campo combinado debe tener el espacio suficiente
                            productField.width = productWidth + packageWidth + emptyWidth

                            // Ocultar campo de package (ya está combinado en el producto)
                            packageField.value = ''
                            packageField.width = 0
                            packageField.height = 0
                        }
                    }
                }
            } catch (error) {
                logError('Error en adjustProductPackageFields:', error)
                // No hacer nada si hay error, dejar el preview como está
            }
        },

        /**
         * Prepara los datos de preview para el modal de grupo
         */
        prepareGroupTimerPreview(timer) {
            if (!timer) return

            const product = this.$store.getters['timerproduct/getProducts'](timer.reference_id)
            if (!product) return

            const stateCfg = this.resolveTimerProductState(product, timer)
            const formatId = stateCfg ? stateCfg.format : null
            if (!formatId) return

            const format = this.resolveFormatForTimerPreview(formatId)
            if (!format) return

            const data = { ...timer.data }
            const hasRealisticPreview = Boolean(format.realistic_preview)
            const { previewData, isZpl } = this.buildTimerLabelPreview({ format, data, product, previewTarget: 'group' })
            this.groupPreviewTimer = isZpl || hasRealisticPreview ? previewData || {} : {}
        },

        /**
         * Prepara las opciones de movimiento para el timer seleccionado en el grupo
         * Replica exactamente la lógica de showPopupOptionsTimer para timers individuales
         */
        prepareGroupMoveOptions(timer) {
            if (!timer) return

            const product = this.$store.getters['timerproduct/getProducts'](timer.reference_id)

            // Reiniciar todas las opciones
            this.groupCanPrintTimer = false
            this.groupCanMoveTimer = false
            this.groupCanMoveBackTimer = false
            this.groupNextMoveStates = []
            this.groupPreviousMoveState = null

            if (!product) {
                logError('Producto no encontrado para timer:', timer.id)
                return
            }

            // Verificar si puede imprimir
            this.groupCanPrintTimer = product.states && product.states[timer.state] && parseInt(product.states[timer.state].type) === 3

            // Si el timer está vencido, no puede moverse ni imprimirse
            if (timer.status <= TIMERPRODUCT_STATUS.EXPIRED) {
                this.groupCanMoveTimer = false
                this.groupCanPrintTimer = false
                return
            }

            // Encontrar estado actual
            let currentStateOrder = -1
            let currentStateId = -1
            this.columns.forEach((state) => {
                if (state.id == timer.state) {
                    currentStateOrder = state.order
                    currentStateId = state.id
                } else if (state.id && state.channel) {
                    let idState = this.timerProductStateBaseId(state.id)
                    if (idState == timer.state && ((!timer.data.channel && state.channel == 1) || timer.data.channel == state.channel)) {
                        currentStateOrder = state.order
                        currentStateId = state.id
                    }
                }
            })

            // Encontrar estado anterior (solo si moved_from_state coincide)
            let previousState = false
            let previousStateName = false
            let previousStateOrder = -1

            this.columns.forEach((state) => {
                if (state.order < currentStateOrder && state.order > previousStateOrder) {
                    previousState = state.id
                    previousStateName = state.name
                    previousStateOrder = state.order
                }
            })

            if (previousState) {
                const previousStateBase = this.timerProductStateBaseId(previousState)
                let bPreviousStateFound = product.states && typeof product.states[previousStateBase] !== 'undefined'
                if (bPreviousStateFound && previousStateBase == timer.data.moved_from_state && this.isUiMoveBackAllowed(timer.reference_id, timer)) {
                    this.groupPreviousMoveState = { name: previousStateName, id: previousState }
                } else {
                    this.groupPreviousMoveState = null
                }
            } else {
                this.groupPreviousMoveState = null
            }

            // Encontrar todos los estados siguientes
            let bFound = false
            const nextStates = []

            this.columns.forEach((state) => {
                // Buscar estados con order >= currentStateOrder pero id diferente al actual
                if (state.order >= currentStateOrder && state.id != currentStateId) {
                    let nextState = state.id
                    if (nextState) {
                        const nextStateBase = this.timerProductStateBaseId(nextState)
                        let bStateFound = typeof product.states[nextStateBase] !== 'undefined'
                        if (bStateFound) {
                            bFound = true
                            // Evitar duplicados
                            if (!nextStates.find((s) => s.id === state.id)) {
                                nextStates.push({ name: state.name, id: state.id })
                            }
                        }
                    }
                }
            })

            if (bFound && nextStates.length > 0) {
                this.groupCanMoveTimer = timer.status != TIMERPRODUCT_STATUS.PREPARATION
                this.groupNextMoveStates = nextStates
            } else {
                this.groupCanMoveTimer = false
                this.groupNextMoveStates = []
            }
            // Retroceso: igual que popup individual (canMoveBackTimer), también en PREPARATION si aplica UI.
            this.groupCanMoveBackTimer = Boolean(this.groupPreviousMoveState)
        },

        /**
         * Construye las características del grupo a partir de un timer
         * @param {Object} timer - El timer del cual extraer las características
         * @returns {Object|null} - Objeto con reference_id, state, date_timestamp, channel o null si el timer no es válido
         */
        buildGroupCharacteristics(timer) {
            if (!timer || !timer.reference_id) {
                return null
            }
            return {
                reference_id: timer.reference_id,
                state: timer.state,
                date_timestamp: timer.data ? timer.data.date_timestamp : null,
                channel: timer.data ? timer.data.channel : 1
            }
        },

        /**
         * Busca timers del grupo en el store usando las características del grupo
         * @param {Object} groupCharacteristics - Características del grupo (reference_id, state, date_timestamp, channel)
         * @param {Object} timersStore - Objeto con todos los timers del store
         * @returns {Array} - Array de timers que coinciden con las características
         */
        findGroupTimersFromStore(groupCharacteristics, timersStore) {
            if (!groupCharacteristics) {
                return []
            }

            const allTimers = Object.values(timersStore)
            const matchingTimers = []

            for (const timer of allTimers) {
                if (timer && timer.data) {
                    const matchesReference = timer.reference_id === groupCharacteristics.reference_id
                    const matchesState = timer.state === groupCharacteristics.state
                    const matchesDate = timer.data.date_timestamp === groupCharacteristics.date_timestamp
                    // eslint-disable-next-line eqeqeq
                    const matchesChannel = (timer.data.channel || 1) == groupCharacteristics.channel

                    if (matchesReference && matchesState && matchesDate && matchesChannel) {
                        matchingTimers.push(timer)
                    }
                }
            }

            return matchingTimers
        },

        /**
         * Refresca y filtra timers del grupo desde el store
         * @param {Array} timersToRefresh - Array de timers a refrescar
         * @param {Object} timersStore - Objeto con todos los timers del store
         * @returns {Array} - Array de timers refrescados con datos del store, filtrados por id válido
         */
        refreshAndFilterTimers(timersToRefresh, timersStore) {
            return timersToRefresh
                .filter((timer) => timer && timer.id) // Asegurar que todos los timers tengan id
                .map((timer) => {
                    const freshTimer = timersStore[timer.id]
                    if (freshTimer) {
                        return {
                            ...freshTimer,
                            data: freshTimer.data ? { ...freshTimer.data } : null
                        }
                    }
                    // Solo retornar timer original si tiene id válido
                    return timer.id
                        ? {
                              ...timer,
                              data: timer.data ? { ...timer.data } : null
                          }
                        : null
                })
                .filter(Boolean) // Filtrar cualquier timer null o undefined
        },

        /**
         * Obtiene las características del grupo desde múltiples fuentes posibles
         * @param {Object} timersStore - Objeto con todos los timers del store
         * @param {string|null} currentTimerId - ID del timer actualmente seleccionado
         * @returns {Object|null} - Características del grupo o null si no se pueden obtener
         */
        getGroupCharacteristicsFromMultipleSources(timersStore, currentTimerId) {
            // PRIMERO: Usar las características guardadas cuando se abrió el modal (más confiable)
            if (this.savedGroupCharacteristics) {
                return this.savedGroupCharacteristics
            }

            // SEGUNDO: Intentar obtener las características del grupo actual si aún hay timers
            if (this.groupTimers.length > 0 && this.groupTimers[0] && this.groupTimers[0].id) {
                const characteristics = this.buildGroupCharacteristics(this.groupTimers[0])
                if (characteristics) {
                    this.savedGroupCharacteristics = characteristics
                    return characteristics
                }
            }

            // TERCERO: Usar el timer seleccionado si existe
            if (currentTimerId && timersStore[currentTimerId]) {
                return this.buildGroupCharacteristics(timersStore[currentTimerId])
            }

            // CUARTO: Buscar timers que puedan pertenecer al grupo
            const allTimers = Object.values(timersStore)
            for (const timer of allTimers) {
                if (timer && timer.data) {
                    // Buscar otros timers que coincidan con este
                    const matchingTimers = allTimers.filter(
                        (t) =>
                            t &&
                            t.data &&
                            t.reference_id === timer.reference_id &&
                            t.state === timer.state &&
                            t.data.date_timestamp === timer.data.date_timestamp &&
                            // eslint-disable-next-line eqeqeq
                            (t.data.channel || 1) == (timer.data.channel || 1)
                    )

                    // Si hay más de 1 timer que coincide, usar esas características
                    if (matchingTimers.length > 1) {
                        return this.buildGroupCharacteristics(timer)
                    }
                }
            }

            // QUINTO: Intentar desde localStorage
            const savedTimersUpdate = JSON.parse(localStorage.getItem('deletedTimersUpdate') || '[]')
            const savedTimersFullDelete = JSON.parse(localStorage.getItem('deletedTimersFullDelete') || '[]')
            const savedTimers = savedTimersFullDelete.length > 0 ? savedTimersFullDelete : savedTimersUpdate.length > 0 ? savedTimersUpdate.map((t) => timersStore[t.id]).filter(Boolean) : []

            if (savedTimers.length > 0) {
                const firstSavedTimer = savedTimers[0]
                if (firstSavedTimer.reference_id || (firstSavedTimer.id && timersStore[firstSavedTimer.id])) {
                    const timerToUse = firstSavedTimer.id && timersStore[firstSavedTimer.id] ? timersStore[firstSavedTimer.id] : firstSavedTimer
                    return this.buildGroupCharacteristics(timerToUse)
                }
            }

            // SEXTO: Buscar usando findTimerGroup con cualquier timer disponible
            for (const timer of allTimers) {
                if (timer && timer.id) {
                    const group = this.findTimerGroup(timer.id)
                    if (group && group.groupedTimers && group.groupedTimers.length > 1) {
                        const firstTimer = group.groupedTimers[0]
                        return this.buildGroupCharacteristics(firstTimer)
                    }
                }
            }

            return null
        },

        /**
         * Resetea el estado de selección del grupo de timers
         */
        resetGroupSelectionState() {
            this.selectedGroupTimer = null
            this.groupPreviewTimer = {}
            this.groupIsZplPreview = false
            this.groupCanMoveTimer = false
            this.groupCanMoveBackTimer = false
            this.groupCanPrintTimer = false
            this.groupPreviousMoveState = null
            this.groupNextMoveStates = []
        },

        /**
         * Actualiza el modal de grupo después de restaurar timers
         * para refrescar los contadores de unidades disponibles
         */
        async updateGroupModalAfterRestore() {
            // Solo actualizar si el modal de grupo está abierto
            if (!this.popupGroupTimerOpen) {
                return
            }

            // Esperar múltiples ticks para asegurar que el store y los computed se actualicen
            await this.$nextTick()
            await this.$nextTick()
            // Esperar más tiempo para asegurar que las actualizaciones del store se hayan propagado
            // y que el computed columnTimers se recalcule completamente después de restaurar timers
            // Aumentar el tiempo de espera para dar más tiempo a que los timers restaurados se actualicen
            await new Promise((resolve) => setTimeout(resolve, 1200))

            const timers = this.$store.getters['timerproduct/getTimers']
            const currentTimerId = this.selectedGroupTimer ? this.selectedGroupTimer.id : null

            // Obtener las características del grupo usando función helper que consolida toda la lógica
            let groupCharacteristics = this.getGroupCharacteristicsFromMultipleSources(timers, currentTimerId)

            // Si aún no tenemos características después de todos los intentos, usar las guardadas o retornar
            if (!groupCharacteristics) {
                if (this.savedGroupCharacteristics) {
                    groupCharacteristics = this.savedGroupCharacteristics
                } else {
                    // No podemos continuar sin características
                    return
                }
            }

            // SIEMPRE construir el grupo manualmente usando las características guardadas
            // Esto asegura que incluya todos los timers restaurados, incluso si el grupo aún no se ha recalculado
            // IMPORTANTE: Obtener los timers del store NUEVAMENTE para asegurar que tenemos los datos más recientes
            const allTimers = Object.values(this.$store.getters['timerproduct/getTimers'])

            // Buscar timers usando función helper
            let restoredGroupTimers = this.findGroupTimersFromStore(groupCharacteristics, this.$store.getters['timerproduct/getTimers'])

            // SIEMPRE usar findTimerGroup con uno de los timers actuales del grupo para encontrar TODOS los timers
            // Esto es más confiable que buscar por características porque findTimerGroup encuentra el grupo completo
            // incluyendo timers que acaban de ser restaurados
            let groupFromFind = null

            // PRIMERO: Intentar usar uno de los timers actuales del grupo si existen
            if (this.groupTimers.length > 0 && this.groupTimers[0] && this.groupTimers[0].id) {
                groupFromFind = this.findTimerGroup(this.groupTimers[0].id)
            }

            // SEGUNDO: Si no encontramos grupo con el timer actual, usar uno de los timers encontrados
            if (!groupFromFind && restoredGroupTimers.length > 0 && restoredGroupTimers[0].id) {
                groupFromFind = this.findTimerGroup(restoredGroupTimers[0].id)
            }

            // TERCERO: Si aún no encontramos grupo, buscar en todos los timers del store
            if (!groupFromFind) {
                for (const timer of allTimers) {
                    if (timer && timer.id) {
                        const tempGroup = this.findTimerGroup(timer.id)
                        if (tempGroup && tempGroup.groupedTimers) {
                            // Verificar si el grupo encontrado coincide con las características guardadas
                            const firstGroupTimer = tempGroup.groupedTimers[0]
                            if (
                                firstGroupTimer &&
                                firstGroupTimer.reference_id === groupCharacteristics.reference_id &&
                                firstGroupTimer.state === groupCharacteristics.state &&
                                firstGroupTimer.data &&
                                firstGroupTimer.data.date_timestamp === groupCharacteristics.date_timestamp &&
                                // eslint-disable-next-line eqeqeq
                                (firstGroupTimer.data.channel || 1) == groupCharacteristics.channel
                            ) {
                                groupFromFind = tempGroup
                                break
                            }
                        }
                    }
                }
            }

            // Si encontramos un grupo con findTimerGroup, usar TODOS sus timers
            if (groupFromFind && groupFromFind.groupedTimers) {
                const existingIds = new Set(restoredGroupTimers.map((t) => t.id))

                // Obtener todos los timers del grupo desde el store
                for (const groupTimer of groupFromFind.groupedTimers) {
                    const timerFromStore = timers[groupTimer.id]
                    if (timerFromStore && !existingIds.has(timerFromStore.id)) {
                        restoredGroupTimers.push(timerFromStore)
                        existingIds.add(timerFromStore.id)
                    }
                }
            }

            // Filtrar timers que tienen unidades disponibles (quantityAvailable > 0)
            // IMPORTANTE: Solo contar timers con unidades > 0 para determinar si cerrar el modal
            let finalGroupTimers = restoredGroupTimers.filter((timer) => {
                if (!timer || !timers[timer.id]) {
                    return false
                }
                const quantityAvailable = this.getValidQuantity(timer)
                // Incluir solo timers con unidades disponibles
                const hasUnits = quantityAvailable !== null && quantityAvailable > 0
                return hasUnits
            })

            // Si no hay timers con unidades pero hay timers en restoredGroupTimers,
            // puede ser que el timer restaurado aún no tenga unidades disponibles
            // Usar restoredGroupTimers directamente para mostrar todos los timers del grupo
            if (finalGroupTimers.length === 0 && restoredGroupTimers.length > 0) {
                // No filtrar por unidades, usar todos los timers del grupo
                finalGroupTimers = restoredGroupTimers
            }

            // IMPORTANTE: Siempre esperar un poco más y buscar nuevamente para asegurar que encontramos
            // TODOS los timers restaurados, especialmente cuando se restaura un timer completamente eliminado

            // Esperar más tiempo y buscar nuevamente para asegurar que encontramos todos los timers restaurados
            await this.$nextTick()
            await new Promise((resolve) => setTimeout(resolve, 800))

            // Re-buscar TODOS los timers del grupo nuevamente con los datos más recientes del store
            const refreshedTimers = this.$store.getters['timerproduct/getTimers']
            let refreshedRestoredGroupTimers = []

            // SIEMPRE usar findTimerGroup primero para encontrar el grupo completo
            // Esto es más confiable que buscar por características
            let refreshedGroupFromFind = null

            // Usar uno de los timers actuales del grupo si existen
            if (this.groupTimers.length > 0 && this.groupTimers[0] && this.groupTimers[0].id && refreshedTimers[this.groupTimers[0].id]) {
                refreshedGroupFromFind = this.findTimerGroup(this.groupTimers[0].id)
            }

            // Si no encontramos grupo con el timer actual, buscar en restoredGroupTimers
            if (!refreshedGroupFromFind && restoredGroupTimers.length > 0 && restoredGroupTimers[0].id && refreshedTimers[restoredGroupTimers[0].id]) {
                refreshedGroupFromFind = this.findTimerGroup(restoredGroupTimers[0].id)
            }

            // Si encontramos un grupo con findTimerGroup, usar TODOS sus timers
            if (refreshedGroupFromFind && refreshedGroupFromFind.groupedTimers) {
                for (const groupTimer of refreshedGroupFromFind.groupedTimers) {
                    if (refreshedTimers[groupTimer.id]) {
                        refreshedRestoredGroupTimers.push(refreshedTimers[groupTimer.id])
                    }
                }
            } else {
                // Si no encontramos grupo con findTimerGroup, buscar por características como respaldo usando función helper
                refreshedRestoredGroupTimers = this.findGroupTimersFromStore(groupCharacteristics, refreshedTimers)
            }

            // Actualizar restoredGroupTimers con los datos más recientes
            restoredGroupTimers.length = 0
            restoredGroupTimers.push(...refreshedRestoredGroupTimers)

            // Filtrar por unidades disponibles usando los datos refrescados
            const refreshedFinalGroupTimers = refreshedRestoredGroupTimers.filter((timer) => {
                if (!timer || !refreshedTimers[timer.id]) {
                    return false
                }
                const quantityAvailable = this.getValidQuantity(timer)
                return quantityAvailable !== null && quantityAvailable > 0
            })

            // Actualizar finalGroupTimers con los datos refrescados
            finalGroupTimers = refreshedFinalGroupTimers

            // IMPORTANTE: NO cerrar el modal cuando se hace "deshacer"
            // Actualizar la lista de timers del modal con TODOS los timers encontrados
            // Incluir tanto los que tienen unidades como los que no (pueden estar siendo restaurados)

            // SIEMPRE usar restoredGroupTimers (todos los timers del grupo) después de la re-búsqueda
            // para asegurar que se muestren TODOS los timers, incluyendo los que acaban de ser restaurados
            // incluso si aún no tienen unidades disponibles
            // restoredGroupTimers ahora contiene los datos más recientes después de la re-búsqueda

            // Obtener los timers más recientes del store para asegurar que tenemos los datos actualizados
            const latestTimers = this.$store.getters['timerproduct/getTimers']

            // Crear un array completamente nuevo con objetos nuevos del store para forzar la reactividad
            let timersToDisplay = []

            if (restoredGroupTimers.length > 0) {
                // Usar función helper para refrescar timers
                timersToDisplay = this.refreshAndFilterTimers(restoredGroupTimers, latestTimers)
            } else if (finalGroupTimers.length > 0) {
                // Usar función helper para refrescar timers
                timersToDisplay = this.refreshAndFilterTimers(finalGroupTimers, latestTimers)
            } else {
                // Si tampoco hay timers, buscar nuevamente usando findTimerGroup
                const allTimersForSearch = Object.values(latestTimers)
                for (const timer of allTimersForSearch) {
                    if (timer && timer.id && groupCharacteristics) {
                        const groupFromFind = this.findTimerGroup(timer.id)
                        if (groupFromFind && groupFromFind.groupedTimers) {
                            // Verificar si el grupo encontrado coincide con las características
                            const firstGroupTimer = groupFromFind.groupedTimers[0]
                            if (
                                firstGroupTimer &&
                                firstGroupTimer.reference_id === groupCharacteristics.reference_id &&
                                firstGroupTimer.state === groupCharacteristics.state &&
                                firstGroupTimer.data &&
                                firstGroupTimer.data.date_timestamp === groupCharacteristics.date_timestamp &&
                                // eslint-disable-next-line eqeqeq
                                (firstGroupTimer.data.channel || 1) == groupCharacteristics.channel
                            ) {
                                timersToDisplay = groupFromFind.groupedTimers
                                    .map((gt) => {
                                        const freshTimer = latestTimers[gt.id]
                                        if (freshTimer) {
                                            return { ...freshTimer }
                                        }
                                        return null
                                    })
                                    .filter(Boolean)
                                break
                            }
                        }
                    }
                }
            }

            // NO actualizar groupTimers aquí - esto se hace más abajo después de verificar que tenemos timers válidos
            // La actualización real se hace más abajo después de preparar newGroupTimers

            // NO hacer verificación final aquí porque ya se hizo arriba
            // Esta verificación estaba causando que se cerrara el modal incorrectamente
            // Solo continuar con la actualización del modal
            // La actualización del timer seleccionado se hará DESPUÉS de actualizar groupTimers más abajo

            // Verificación final: si timersToDisplay está vacío después de todas las búsquedas,
            // intentar una última búsqueda después de esperar más tiempo
            if (timersToDisplay.length === 0) {
                await new Promise((resolve) => setTimeout(resolve, 800))

                const finalTimers = this.$store.getters['timerproduct/getTimers']
                const finalRestoredGroupTimers = []

                // Si tenemos groupCharacteristics, buscar con ellas
                if (groupCharacteristics) {
                    // Buscar todos los timers que coincidan con las características
                    for (const timer of Object.values(finalTimers)) {
                        if (
                            timer &&
                            timer.data &&
                            timer.reference_id === groupCharacteristics.reference_id &&
                            timer.state === groupCharacteristics.state &&
                            timer.data.date_timestamp === groupCharacteristics.date_timestamp &&
                            // eslint-disable-next-line eqeqeq
                            (timer.data.channel || 1) == groupCharacteristics.channel
                        ) {
                            finalRestoredGroupTimers.push(timer)
                        }
                    }

                    // También buscar usando findTimerGroup
                    if (finalRestoredGroupTimers.length > 0) {
                        const firstFoundTimer = finalRestoredGroupTimers[0]
                        const groupFromFind = this.findTimerGroup(firstFoundTimer.id)
                        if (groupFromFind && groupFromFind.groupedTimers) {
                            const existingIds = new Set(finalRestoredGroupTimers.map((t) => t.id))
                            for (const groupTimer of groupFromFind.groupedTimers) {
                                if (!existingIds.has(groupTimer.id) && finalTimers[groupTimer.id]) {
                                    finalRestoredGroupTimers.push(finalTimers[groupTimer.id])
                                    existingIds.add(groupTimer.id)
                                }
                            }
                        }
                    }
                }

                // Si aún no encontramos timers y tenemos groupCharacteristics, buscar usando findTimerGroup con cualquier timer
                if (finalRestoredGroupTimers.length === 0 && groupCharacteristics) {
                    for (const timer of Object.values(finalTimers)) {
                        if (timer && timer.id) {
                            const groupFromFind = this.findTimerGroup(timer.id)
                            if (groupFromFind && groupFromFind.groupedTimers) {
                                const firstGroupTimer = groupFromFind.groupedTimers[0]
                                if (
                                    firstGroupTimer &&
                                    firstGroupTimer.reference_id === groupCharacteristics.reference_id &&
                                    firstGroupTimer.state === groupCharacteristics.state &&
                                    firstGroupTimer.data &&
                                    firstGroupTimer.data.date_timestamp === groupCharacteristics.date_timestamp &&
                                    // eslint-disable-next-line eqeqeq
                                    (firstGroupTimer.data.channel || 1) == groupCharacteristics.channel
                                ) {
                                    finalRestoredGroupTimers.push(...groupFromFind.groupedTimers.map((gt) => finalTimers[gt.id]).filter(Boolean))
                                    break
                                }
                            }
                        }
                    }
                }

                // Si aún no encontramos timers, usar el grupo actual si existe
                if (finalRestoredGroupTimers.length === 0 && this.groupTimers.length > 0) {
                    // Obtener los timers más recientes del store para los timers actuales
                    // Filtrar solo timers que tienen id válido antes de mapear
                    const refreshedCurrentTimers = this.groupTimers
                        .filter((timer) => timer && timer.id)
                        .map((timer) => {
                            const freshTimer = finalTimers[timer.id]
                            if (freshTimer) {
                                return { ...freshTimer, data: freshTimer.data ? { ...freshTimer.data } : null }
                            }
                            // Solo retornar timer original si tiene id válido
                            return timer.id ? timer : null
                        })
                        .filter(Boolean)

                    // Solo usar los timers actuales si realmente existen en el store
                    if (refreshedCurrentTimers.length > 0) {
                        timersToDisplay = refreshedCurrentTimers
                    }
                } else if (finalRestoredGroupTimers.length > 0) {
                    // Usar función helper para refrescar timers
                    timersToDisplay = this.refreshAndFilterTimers(finalRestoredGroupTimers, finalTimers)
                }
            }

            // Obtener los timers más recientes del store ANTES de hacer cualquier cambio
            const refreshedLatestTimers = this.$store.getters['timerproduct/getTimers']

            // Preparar los nuevos timers ANTES de vaciar groupTimers usando función helper
            // Esto asegura que tenemos datos válidos antes de hacer el cambio
            const newGroupTimers = this.refreshAndFilterTimers(timersToDisplay, refreshedLatestTimers)

            // NO actualizar groupTimers si newGroupTimers está vacío
            // PERO si groupTimers actual también está vacío, intentar refrescar los timers actuales del store
            if (newGroupTimers.length === 0) {
                // Si groupTimers actual tiene timers, intentar refrescarlos del store usando función helper
                if (this.groupTimers.length > 0) {
                    const refreshedCurrentTimers = this.refreshAndFilterTimers(this.groupTimers, refreshedLatestTimers)

                    if (refreshedCurrentTimers.length > 0) {
                        this.groupTimers = [...refreshedCurrentTimers]
                        await this.$nextTick()
                        this.$forceUpdate()
                        return
                    }
                }

                return
            }

            // Solo ahora que tenemos confirmación de que hay timers válidos, actualizar groupTimers
            // Forzar actualización del componente modal de manera más agresiva
            // Primero vaciar el array para forzar el cambio y que Vue detecte la diferencia
            this.groupTimers = []

            await this.$nextTick()
            await this.$nextTick()

            // Luego asignar los nuevos timers con una referencia completamente nueva
            this.groupTimers = [...newGroupTimers]

            // Actualizar las características guardadas con el grupo actualizado
            // para futuras restauraciones
            if (this.groupTimers.length > 0 && this.groupTimers[0]) {
                this.savedGroupCharacteristics = this.buildGroupCharacteristics(this.groupTimers[0])
            }

            await this.$nextTick()

            // Forzar actualización del componente padre
            this.$forceUpdate()

            // Esperar más ticks para asegurar que Vue procese todos los cambios
            await this.$nextTick()
            await this.$nextTick()

            // Crear una nueva referencia del array nuevamente para forzar la reactividad
            this.groupTimers = [...this.groupTimers]

            await this.$nextTick()

            // Actualizar el timer seleccionado si aún existe en el grupo
            // Usar this.groupTimers que ahora incluye TODOS los timers del grupo
            const currentTimers = this.$store.getters['timerproduct/getTimers']
            if (currentTimerId && currentTimers[currentTimerId]) {
                const timerStillInGroup = this.groupTimers.find((t) => t.id === currentTimerId)
                const updatedTimer = currentTimers[currentTimerId]
                const quantityAvailable = this.getValidQuantity(updatedTimer)

                if (timerStillInGroup && quantityAvailable !== null && quantityAvailable > 0) {
                    // El timer aún existe, tiene unidades y está en el grupo, mantenerlo seleccionado
                    this.selectedGroupTimer = updatedTimer
                    this.prepareGroupTimerPreview(updatedTimer)
                    this.prepareGroupMoveOptions(updatedTimer)
                } else {
                    // El timer seleccionado ya no está en el grupo o no tiene unidades, resetear selección
                    this.resetGroupSelectionState()
                }
            } else {
                // No hay timer seleccionado, resetear selección para mostrar el mensaje
                this.resetGroupSelectionState()
            }

            await this.$nextTick()

            // Forzar actualización nuevamente después de esperar
            this.$forceUpdate()
        },

        /**
         * Cierra el modal de grupo
         */
        closePopupGroupTimer() {
            // Cerrar el modal completamente y limpiar todo el estado
            this.popupGroupTimerOpen = false
            this.groupTimers = []
            this.resetGroupSelectionState()
            this.savedGroupCharacteristics = null

            // Asegurar que el modal esté completamente cerrado
            // Esperar un tick para asegurar que Vue procese el cambio
            this.$nextTick(() => {
                // Verificación adicional: si por alguna razón el modal se abrió de nuevo, cerrarlo
                if (this.popupGroupTimerOpen && this.groupTimers.length <= 1) {
                    this.popupGroupTimerOpen = false
                    this.groupTimers = []
                    this.selectedGroupTimer = null
                    this.savedGroupCharacteristics = null
                }
            })
        },

        /**
         * Maneja la selección de un timer diferente en el modal de grupo
         */
        handleGroupTimerSelected(timer, options) {
            this.selectedGroupTimer = timer

            // Si hay múltiples timers seleccionados, no preparar preview individual
            // El backend ya envía preview_not_available en groupPreviewTimer
            if (!options || !options.isMultiple || options.count <= 1) {
                this.prepareGroupTimerPreview(timer)
            }

            this.prepareGroupMoveOptions(timer)
        },

        /**
         * Valida que un timer existe y muestra error si no existe, cerrando el popup
         * @param {string} timerId - ID del timer a validar
         * @returns {boolean} - true si el timer existe, false si no existe
         */
        validateTimerAndShowError(timerId) {
            const timers = this.$store.getters['timerproduct/getTimers']
            if (!timers[timerId]) {
                this.$snackbar.error({
                    message: this.$t('timers.timer_not_found'),
                    closeable: true
                })
                this.closePopupGroupTimer()
                return false
            }
            return true
        },

        /**
         * Valida múltiples timers y filtra solo los que existen en el store
         * @param {Array<string>} timerIds - Array de IDs de timers a validar
         * @returns {Array<string>} - Array de IDs válidos, o null si ninguno es válido
         */
        validateMultipleTimers(timerIds) {
            if (!timerIds || timerIds.length === 0) {
                return null
            }
            const timers = this.$store.getters['timerproduct/getTimers']
            const validTimerIds = timerIds.filter((id) => timers[id])
            return validTimerIds.length > 0 ? validTimerIds : null
        },

        /**
         * Valida múltiples timers, muestra error si ninguno es válido y cierra el popup
         * @param {Array<string>} timerIds - Array de IDs de timers a validar
         * @returns {Array<string>} - Array de IDs válidos, o null si ninguno es válido
         */
        validateMultipleTimersAndShowError(timerIds) {
            const validTimerIds = this.validateMultipleTimers(timerIds)
            if (!validTimerIds) {
                this.$snackbar.error({
                    message: this.$t('timers.timer_not_found'),
                    closeable: true
                })
                this.closePopupGroupTimer()
                return null
            }
            return validTimerIds
        },

        /**
         * Extrae un valor de cantidad válido de un timer, manejando NaN, null, undefined y strings vacíos
         * @param {Object} timer - Timer object con data.quantity_avaibles y data.quantity
         * @returns {number|null} - Valor numérico válido o null si no hay valor válido
         */
        getValidQuantity(timer) {
            if (!timer || !timer.data) {
                return null
            }

            // Intentar usar quantity_avaibles primero
            const quantityAvaibles = timer.data.quantity_avaibles
            if (quantityAvaibles !== 'NaN' && quantityAvaibles !== null && quantityAvaibles !== undefined && quantityAvaibles !== '') {
                const parsed = parseInt(quantityAvaibles)
                if (!isNaN(parsed)) {
                    return parsed
                }
            }

            // Fallback a quantity
            const quantity = timer.data.quantity
            if (quantity !== null && quantity !== undefined && quantity !== '') {
                const parsed = parseInt(quantity)
                if (!isNaN(parsed)) {
                    return parsed
                }
            }

            return null
        },

        /**
         * Construye el mensaje apropiado para la eliminación de timers
         * @param {boolean} skipLocalStorage - Indica si es eliminación múltiple
         * @returns {Object} - Objeto con message e isMixedTypes
         */
        getDeleteMessage(skipLocalStorage) {
            const updateTimers = JSON.parse(localStorage.getItem('deletedTimersUpdate') || '[]')
            const fullDeleteTimers = JSON.parse(localStorage.getItem('deletedTimersFullDelete') || '[]')
            const isMixedTypes = updateTimers.length > 0 && fullDeleteTimers.length > 0

            let message
            if (isMixedTypes) {
                // Tipos mixtos: informar ambos tipos de eliminación
                message = `${updateTimers.length} timer(s) con cantidad reducida, ${fullDeleteTimers.length} timer(s) eliminados`
            } else if (!skipLocalStorage) {
                // Caso individual
                message = this.$t(this.deletedTimerCount > 1 ? 'timers.remove_timers_units' : 'timers.remove_timers_unit', {
                    timers: this.deletedTimerCount
                })
            } else {
                // Caso múltiple, solo updates
                if (updateTimers.length > 0) {
                    message = this.$t('timers.remove_timers_units', { timers: this.deletedTimerCount }) + ` (${updateTimers.length} timers)`
                } else {
                    // Solo full delete
                    message = this.$tc('timers.remove_timers', fullDeleteTimers.length, { timers: fullDeleteTimers.length })
                }
            }

            return { message, isMixedTypes }
        },

        /**
         * Maneja el movimiento de un timer desde el modal de grupo
         * Usa la misma lógica que moveTimerNextState con todas las verificaciones
         * Actualiza el modal en tiempo real sin cerrarlo
         */
        async handleGroupMoveTimer(params) {
            const { timerId, timerIds, nextState, count, index, isMultiple, isBackwardMove } = params

            // Configurar contadores de movimiento (común para ambos casos)
            this.movedTimerCount1 = index === 0 ? count : 1
            this.movedTimerCount2 = index === 1 ? count : 1
            this.movedBackTimerCount = count
            this.canMoveTimer = this.groupCanMoveTimer
            // El modal de grupo se cierra antes del movimiento y borra groupPreviousMoveState;
            // marcamos retroceso aquí para que moveTimerNextState coincida con showPopupOptionsTimer (canMoveBackTimer).
            this.canMoveBackTimer = Boolean(isBackwardMove)

            // Validar antes de ejecutar la operación
            let validTimerIds = null
            if (isMultiple && timerIds && timerIds.length > 0) {
                validTimerIds = this.validateMultipleTimersAndShowError(timerIds)
                if (!validTimerIds) {
                    return
                }
            } else if (timerId) {
                // Caso individual: validar que el timer existe
                if (!this.validateTimerAndShowError(timerId)) {
                    return
                }
            }

            // Cerrar el modal inmediatamente al hacer clic
            this.closePopupGroupTimer()

            // Ejecutar las operaciones de movimiento en segundo plano (fire and forget)
            // Si hay un error, se mostrará un mensaje pero el modal ya estará cerrado
            try {
                if (isMultiple && validTimerIds && validTimerIds.length > 0) {
                    this.groupMoveCollectingPrintConfirmIds = true
                    this.pendingGroupMovePrintTimerIds = []
                    this.pendingPrintIsAfterMove = false
                    // allSettled (no Promise.all): si uno falla, esperar igual al resto para que no sigan ejecutándose queuePrintConfirmModal tras groupMoveCollectingPrintConfirmIds = false.
                    Promise.allSettled(
                        validTimerIds.map((id) => {
                            return this.moveTimerNextState({
                                timer_id: id,
                                next_state: nextState,
                                index,
                                skipPopupAndClose: true,
                                isBackwardMove
                            })
                        })
                    )
                        .then((results) => {
                            const rejected = results.filter((r) => r.status === 'rejected')
                            if (rejected.length > 0) {
                                this.$snackbar.error({
                                    closeable: true,
                                    message: this.$t('timersproduct.cannot_move') || 'Error al mover el timer'
                                })
                            }
                        })
                        .finally(() => {
                            this.groupMoveCollectingPrintConfirmIds = false
                            const seen = new Set()
                            const collectedIds = []
                            for (const id of this.pendingGroupMovePrintTimerIds) {
                                const k = String(id)
                                if (!seen.has(k)) {
                                    seen.add(k)
                                    collectedIds.push(id)
                                }
                            }
                            this.pendingGroupMovePrintTimerIds = []
                            const afterMove = this.pendingPrintIsAfterMove
                            if (collectedIds.length > 0) {
                                this.queueBatchPrintConfirmModal(collectedIds, false, afterMove)
                            } else {
                                this.pendingPrintIsAfterMove = false
                            }
                        })
                } else if (timerId) {
                    // Ejecutar sin esperar
                    this.moveTimerNextState({
                        timer_id: timerId,
                        next_state: nextState,
                        index,
                        skipPopupAndClose: true,
                        isBackwardMove
                    }).catch(() => {
                        this.$snackbar.error({
                            closeable: true,
                            message: this.$t('timersproduct.cannot_move') || 'Error al mover el timer'
                        })
                    })
                }
            } catch (error) {
                logError('Error al iniciar movimiento de timer(s):', error)
                this.$snackbar.error({
                    closeable: true,
                    message: this.$t('timersproduct.cannot_move') || 'Error al mover el timer'
                })
            }
        },

        /**
         * Maneja la impresión desde el modal de grupo
         * Usa la misma lógica que printLabel individual con todas las verificaciones
         * Uno o varios timers: mismo modal de confirmación que el popup individual antes de imprimir.
         */
        handleGroupPrintTimer(params) {
            const { timerId, timerIds, count, isMultiple } = params

            // Varios timers: un solo modal de confirmación y luego impresión en paralelo
            if (isMultiple && timerIds && timerIds.length > 0) {
                const validTimerIds = this.validateMultipleTimersAndShowError(timerIds)
                if (!validTimerIds) {
                    return
                }

                this.printedTimerCount = count
                this.closePopupGroupTimer()
                this.queueBatchPrintConfirmModal(validTimerIds, true)
                return
            } else if (timerId) {
                // Caso individual: validar que el timer existe
                if (!this.validateTimerAndShowError(timerId)) {
                    return
                }

                this.printedTimerCount = count
                this.closePopupGroupTimer()
                this.queuePrintConfirmModal(timerId, false, true)
                return
            }
        },

        /**
         * Maneja la eliminación desde el modal de grupo
         * Desde el modal, se eliminan solo los timers seleccionados individualmente, no todo el grupo
         * Actualiza el modal en tiempo real sin cerrarlo
         */
        async handleGroupDeleteTimer(params) {
            const { timerId, timerIds, count, isMultiple } = params || {}

            // Validar parámetros antes de limpiar localStorage
            const hasMultipleTimers = isMultiple && timerIds && timerIds.length > 0
            const hasSingleTimer = timerId

            if (!hasMultipleTimers && !hasSingleTimer) {
                // No hay timers válidos para procesar, no limpiar localStorage
                return
            }

            // IMPORTANTE: Guardar las características del grupo ANTES de eliminar
            // para poder buscar correctamente después de la eliminación
            // SIEMPRE guardar las características si no están guardadas, incluso si el grupo está vacío
            if (!this.savedGroupCharacteristics) {
                if (this.groupTimers.length > 0 && this.groupTimers[0]) {
                    this.savedGroupCharacteristics = this.buildGroupCharacteristics(this.groupTimers[0])
                } else {
                    // Si no hay groupTimers, intentar obtener las características del timer que se va a eliminar
                    const timers = this.$store.getters['timerproduct/getTimers']
                    const timerToDelete = hasSingleTimer ? timers[timerId] : hasMultipleTimers && timerIds && timerIds.length > 0 ? timers[timerIds[0]] : null
                    if (timerToDelete) {
                        this.savedGroupCharacteristics = this.buildGroupCharacteristics(timerToDelete)
                    }
                }
            }

            // Si hay múltiples timers seleccionados, eliminar solo los seleccionados (no todo el grupo)
            if (hasMultipleTimers) {
                const validTimerIds = this.validateMultipleTimersAndShowError(timerIds)
                if (!validTimerIds) {
                    // Validación falló: timers no existen en el store, no limpiar localStorage
                    return
                }

                // Limpiar localStorage solo después de validar que los timers existen en el store
                localStorage.removeItem('deletedTimersUpdate')
                localStorage.removeItem('deletedTimersFullDelete')

                const timers = this.$store.getters['timerproduct/getTimers']
                // Para múltiples timers desde el modal, siempre eliminar completamente cada timer
                const promises = validTimerIds.map((id, index) => {
                    const timer = timers[id]
                    // Establecer deletedTimerCount a la cantidad completa para eliminar completamente el timer
                    // Usar helper para obtener cantidad válida (maneja NaN, null, undefined y strings vacíos)
                    const validQuantity = this.getValidQuantity(timer)
                    // Si no se pudo obtener un valor válido, usar 1 como fallback para evitar NaN
                    this.deletedTimerCount = validQuantity !== null ? validQuantity : 1

                    // isLastTimer debe basarse en los timers válidos, no en el array original
                    const isLastTimer = index === validTimerIds.length - 1
                    return this.deleteTimer(id, true, isLastTimer, true)
                })

                await Promise.all(promises)
            } else if (hasSingleTimer) {
                // Caso individual: validar que el timer existe usando el helper para consistencia
                if (!this.validateTimerAndShowError(timerId)) {
                    // Validación falló: timer no existe en el store, no limpiar localStorage
                    return
                }

                // Limpiar localStorage solo después de validar que el timer existe en el store
                localStorage.removeItem('deletedTimersUpdate')
                localStorage.removeItem('deletedTimersFullDelete')

                // Caso individual: usar deleteTimer que maneja correctamente la eliminación parcial de unidades
                // skipValidation=true porque ya validamos con validateTimerAndShowError arriba
                this.deletedTimerCount = count || 1
                await this.deleteTimer(timerId, false, false, true, true)
            }

            // ACTUALIZAR EL GRUPO EN TIEMPO REAL en lugar de cerrar el modal
            // Esperar múltiples ticks para asegurar que el store y los computed se actualicen
            await this.$nextTick()
            await this.$nextTick()

            // Esperar más tiempo para asegurar que las actualizaciones del store se hayan propagado completamente
            // después de eliminar unidades, el store necesita tiempo para actualizar las cantidades
            // Aumentar el tiempo de espera para dar más tiempo al store
            await new Promise((resolve) => setTimeout(resolve, 800))

            // Obtener los timers actualizados del store
            const timers = this.$store.getters['timerproduct/getTimers']

            // Obtener las características del grupo - SIEMPRE usar las guardadas si existen
            let groupCharacteristics = null
            if (this.savedGroupCharacteristics) {
                groupCharacteristics = this.savedGroupCharacteristics
            } else {
                // Si no hay características guardadas, intentar obtenerlas del grupo actual o de los timers originales
                const originalGroupTimerIds = this.groupTimers.map((t) => t.id)

                if (this.groupTimers.length > 0 && this.groupTimers[0]) {
                    groupCharacteristics = this.buildGroupCharacteristics(this.groupTimers[0])
                    this.savedGroupCharacteristics = groupCharacteristics
                } else if (originalGroupTimerIds.length > 0) {
                    // Buscar cualquier timer original que aún exista en el store
                    for (const timerId of originalGroupTimerIds) {
                        const timer = timers[timerId]
                        if (timer) {
                            groupCharacteristics = this.buildGroupCharacteristics(timer)
                            this.savedGroupCharacteristics = groupCharacteristics
                            break
                        }
                    }
                }
            }

            // Si no tenemos características del grupo, no podemos continuar
            if (!groupCharacteristics) {
                this.closePopupGroupTimer()
                return
            }

            // Buscar TODOS los timers que coincidan con las características del grupo usando función helper
            // Incluir TODOS los timers que coincidan, incluso si tienen 0 unidades
            const allMatchingTimers = this.findGroupTimersFromStore(groupCharacteristics, timers)

            // Verificación adicional: buscar también usando findTimerGroup para asegurar que encontramos todos
            if (allMatchingTimers.length > 0) {
                const firstFoundTimer = allMatchingTimers[0]
                const groupFromFind = this.findTimerGroup(firstFoundTimer.id)
                if (groupFromFind && groupFromFind.groupedTimers) {
                    // Agregar cualquier timer del grupo encontrado que no esté ya en nuestra lista
                    const existingIds = new Set(allMatchingTimers.map((t) => t.id))
                    for (const groupTimer of groupFromFind.groupedTimers) {
                        if (!existingIds.has(groupTimer.id) && timers[groupTimer.id]) {
                            allMatchingTimers.push(timers[groupTimer.id])
                            existingIds.add(groupTimer.id)
                        }
                    }
                }
            } else {
                // Si no encontramos timers, intentar buscar usando cualquier timer que pueda estar en el grupo
                const originalGroupTimerIds = this.groupTimers.map((t) => t.id)
                for (const timerId of originalGroupTimerIds) {
                    if (timers[timerId]) {
                        const groupFromFind = this.findTimerGroup(timerId)
                        if (groupFromFind && groupFromFind.groupedTimers) {
                            const existingIds = new Set(allMatchingTimers.map((t) => t.id))
                            for (const groupTimer of groupFromFind.groupedTimers) {
                                if (!existingIds.has(groupTimer.id) && timers[groupTimer.id]) {
                                    allMatchingTimers.push(timers[groupTimer.id])
                                    existingIds.add(groupTimer.id)
                                }
                            }
                            break
                        }
                    }
                }
            }

            // Filtrar timers que tienen unidades disponibles (quantityAvailable > 0)
            // IMPORTANTE: Solo contar timers con unidades > 0 para determinar si cerrar el modal
            const finalGroupTimers = allMatchingTimers.filter((timer) => {
                if (!timer || !timers[timer.id]) {
                    return false
                }
                const quantityAvailable = this.getValidQuantity(timer)
                // Incluir solo timers con unidades disponibles
                const hasUnits = quantityAvailable !== null && quantityAvailable > 0
                return hasUnits
            })

            // SOLO cerrar el modal si después de filtrar por unidades disponibles
            // realmente solo queda 1 timer o menos
            // Esto es crítico: no cerrar si hay más de 1 timer con unidades
            // IMPORTANTE: Verificar que realmente hay más de 1 timer ANTES de cerrar
            if (finalGroupTimers.length <= 1) {
                this.closePopupGroupTimer()
                return
            }

            // Actualizar la lista de timers del grupo creando una nueva referencia para forzar reactividad
            this.groupTimers = [...finalGroupTimers]

            // Asegurar que las características del grupo se mantengan guardadas
            // para usar cuando se restaure
            if (this.groupTimers.length > 0 && this.groupTimers[0]) {
                this.savedGroupCharacteristics = this.buildGroupCharacteristics(this.groupTimers[0])
            }

            // Verificar si el timer seleccionado aún existe y tiene unidades disponibles
            const currentSelectedTimerId = this.selectedGroupTimer ? this.selectedGroupTimer.id : null
            let shouldResetSelection = true

            if (currentSelectedTimerId && timers[currentSelectedTimerId]) {
                const updatedSelectedTimer = timers[currentSelectedTimerId]
                const quantityAvailable = this.getValidQuantity(updatedSelectedTimer)

                // Verificar que el timer aún está en el grupo actualizado
                const timerStillInGroup = finalGroupTimers.find((t) => t.id === currentSelectedTimerId)

                // Si el timer aún existe, tiene unidades y está en el grupo, mantenerlo seleccionado
                if (timerStillInGroup && quantityAvailable !== null && quantityAvailable > 0) {
                    // Actualizar el timer seleccionado con los datos más recientes desde el store
                    this.selectedGroupTimer = updatedSelectedTimer
                    this.prepareGroupTimerPreview(updatedSelectedTimer)
                    this.prepareGroupMoveOptions(updatedSelectedTimer)
                    shouldResetSelection = false
                }
            }

            // Solo resetear la selección si el timer ya no tiene unidades o no existe
            if (shouldResetSelection) {
                this.selectedGroupTimer = null
                this.groupPreviewTimer = {}
                this.groupCanMoveTimer = false
                this.groupCanMoveBackTimer = false
                this.groupCanPrintTimer = false
                this.groupPreviousMoveState = null
                this.groupNextMoveStates = []
            }

            // Verificación FINAL antes de forzar actualización
            // Usar finalGroupTimers en lugar de this.groupTimers para asegurar que usamos los datos correctos
            if (finalGroupTimers.length <= 1) {
                this.closePopupGroupTimer()
                return
            }

            // Forzar actualización de Vue para asegurar que los cambios se reflejen
            await this.$nextTick()
            this.$forceUpdate()
        },
    },
    created() {
        this.restoreViewPreferences()
        this.load()
        this.resetRecommendationVisit()
    },
    activated() {
        this.resetRecommendationVisit()
    },
    mounted() {
        var self = this
        const create = self.$route.query.create === 'true'
        if (create) {
            this.show_timers = false
        }

        const option = this.popupOptions.find((opt) => opt.value === this.currentVisibility)

        EventBus.$emit('update-title', { mensaje: this.$t('page_title.' + this.$route.name) + ` (${option.displayText})` })

        this.$store.dispatch('timerproduct/setupInterval', { intervalMs: TIMER_TICK_FAST_MS })
    },
    beforeDestroy() {
        this.$store.dispatch('timerproduct/setupInterval', { intervalMs: TIMER_TICK_SLOW_MS })
        this.$store.dispatch('timerproduct/setActiveKpiFilter', null)
    },
    watch: {
        /**
         * Navegación reactiva board → listado al activar un filtro KPI.
         * No depende del evento de click: cualquier cambio en activeKpiFilter abre el listado.
         */
        activeKpiFilter(filterType) {
            if (filterType && this.show_timers) {
                this.show_timers = false
            }
        },
        show_timers(isBoardVisible) {
            if (isBoardVisible && !this.pendingCombinedRecommendation) {
                this.resetRecommendationVisit()
            }
        },
        getTimers: {
            handler(newTimers, oldTimers) {
                const hasSelectedTimer = Object.values(newTimers).some((timer) => timer.isSelected === true)
                if (!hasSelectedTimer) {
                    this.clickEnabledMulti = false
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.button-with-controls {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 8px;

    .control-button {
        width: 48px !important;
        height: 48px !important;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s ease;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 16px;

        &[aria-disabled='true'] {
            cursor: not-allowed;
            opacity: 0.5;
        }
    }

    .minus-button {
        &.minus-blue-active {
            position: relative;
            background-color: $color-white;
            border: 1px solid $main-text;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $main-text;
                -webkit-mask: img('less_light.svg') no-repeat center;
                mask: img('less_light.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.minus-blue-inactive {
            position: relative;
            background-color: $color-white;
            border: 1px solid $main-text;
            opacity: 0.25;
            pointer-events: none !important;
            cursor: not-allowed !important;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $main-text;
                opacity: 0.45;
                -webkit-mask: img('less_light.svg') no-repeat center;
                mask: img('less_light.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.minus-gray-active {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-black;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $color-black;
                -webkit-mask: img('less_light.svg') no-repeat center;
                mask: img('less_light.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.minus-gray-inactive {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-black;
            opacity: 0.25;
            pointer-events: none !important;
            cursor: not-allowed !important;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $color-black;
                opacity: 0.45;
                -webkit-mask: img('less_light.svg') no-repeat center;
                mask: img('less_light.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.minus-red-active {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-error-500;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $color-error-500;
                -webkit-mask: img('less_light.svg') no-repeat center;
                mask: img('less_light.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.minus-red-inactive {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-error-500;
            opacity: 0.25;
            pointer-events: none !important;
            cursor: not-allowed !important;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                opacity: 0.45;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $color-error-500;
                -webkit-mask: img('less_light.svg') no-repeat center;
                mask: img('less_light.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }
    }

    .plus-button {
        &.plus-blue-active {
            position: relative;
            background-color: $color-white;
            border: 1px solid $main-text;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $main-text;
                -webkit-mask: img('more_ffffff.svg') no-repeat center;
                mask: img('more_ffffff.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.plus-blue-inactive {
            position: relative;
            background-color: $color-white;
            border: 1px solid $main-text;
            opacity: 0.25;
            pointer-events: none !important;
            cursor: not-allowed !important;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $main-text;
                opacity: 0.45;
                -webkit-mask: img('more_ffffff.svg') no-repeat center;
                mask: img('more_ffffff.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.plus-gray-active {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-black;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $color-black;
                -webkit-mask: img('more_ffffff.svg') no-repeat center;
                mask: img('more_ffffff.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.plus-gray-inactive {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-black;
            opacity: 0.25;
            pointer-events: none !important;
            cursor: not-allowed !important;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                opacity: 0.45;
                background-color: $color-black;
                -webkit-mask: img('more_ffffff.svg') no-repeat center;
                mask: img('more_ffffff.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.plus-red-active {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-error-500;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $color-error-500;
                -webkit-mask: img('more_ffffff.svg') no-repeat center;
                mask: img('more_ffffff.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }

        &.plus-red-inactive {
            position: relative;
            background-color: $color-white;
            border: 1px solid $color-error-500;
            opacity: 0.25;
            pointer-events: none !important;
            cursor: not-allowed !important;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: $color-error-500;
                opacity: 0.45;
                -webkit-mask: img('more_ffffff.svg') no-repeat center;
                mask: img('more_ffffff.svg') no-repeat center;
                -webkit-mask-size: contain;
                mask-size: contain;
            }
        }
    }
}

.timers {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;

    .preview {
        margin: 0rem !important;
        margin-bottom: 0rem !important;
        max-height: 100%;

        .zpl-preview-wrapper {
            width: 100%;
            min-height: 0;
            overflow: hidden;
        }

        .quantity {
            margin-top: 1rem;
            text-align: right;

            .units {
                font-weight: 700;
            }
        }
    }

    #board {
        padding: 8px;
        border-radius: 4px;
        width: 100%;
        flex: 1 1 auto;
        min-height: 0;
        height: auto;
        display: flex;
        position: relative;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        gap: 0;
        justify-content: space-evenly;
    }

    &.portrait #board {
        padding: 2px;
        gap: 8px;
        justify-content: flex-start;
    }

    .parent-container {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: 8px !important;
        margin-bottom: 8px !important;
        padding: 0px;
    }

    .start-units {
        width: 201px;
        height: 35px;
    }

    .start-units {
        display: flex;
        padding: 8px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 4px;
        border: 1px solid var(--neutro-dark-app);
        background: var(--neutro-light-app);
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.06);
    }

    .icon-units {
        width: 13px;
        height: 13px;
        background-image: img('package_black.svg');
        background-size: 12px;
        background-repeat: no-repeat;
        background-position: center;
    }

    .number-units {
        font-family: $text-bold;
        font-size: 16px;
        color: $neutro-s90;
    }

    .text-units {
        font-size: 16px;
        color: $neutro-s90;
    }

    .list {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        position: relative;

        .content-button {
            padding: 0 !important;
        }

        .selector-cancel-btn {
            width: 100%;
            margin: 0px;
        }

        .item-list {
            padding: 8px;
            display: flex;
            align-items: center;
            gap: 12px;
            cursor: pointer;
            width: 98%;
            margin: 8px 0;
            border: 1px solid $color-neutral-300;
            @include border-radius(4px);
            transition: all 0.3s ease-in-out;

            &.non-scroll {
                width: 100%;
            }

            &:hover {
                background-color: $color-selector;
            }

            &.selected {
                background-color: $color-neutral-200;
            }

            &.clear-value {
                color: $color-letter-selector;
                width: 100%;
                padding-right: 8px;
                font-size: 1.1em;
                padding-left: 38px;
                padding-right: 8px;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                overflow-wrap: anywhere;
            }
        }

        &.portrait {
            .clear-value {
                font-size: 0.8em;
            }
        }

        .items-list {
            margin-top: 2px;
            max-height: 280px;
            overflow-y: auto;
            padding-right: 8px;
            width: 100%;

            &.mobile-landscape {
                max-height: 205px;

                .selector-item {
                    font-size: 0.8em;
                    min-height: 1.2em;
                    color: $color-letter-selector;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    overflow-wrap: anywhere;
                }
            }

            .selector-color {
                padding: 5px;
                @include border-radius(100%);
                margin-left: 8px;

                &.no-color {
                    border: 1px solid $color-selector2;
                    position: relative;
                }
            }

            .selector-item {
                font-size: 1.1em;
                min-height: 1.2em;
                color: $color-letter-selector;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    /* BUILD-7551: modal Cambiar vista (secciones + Apply/Cancel) */
    .change-view-modal {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 22px;
        min-height: 360px;
        box-sizing: border-box;

        &__section {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 10px;
        }

        &__section-title {
            margin: 0;
            padding: 0 2px;
            font-family: $text-bold;
            font-size: 16px;
            line-height: 1.3;
            color: $color-neutral-800;
        }

        &__options {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 8px;
        }

        &__option {
            @include display-flex();
            @include align-items(center);
            width: 100%;
            gap: 12px;
            padding: 12px 14px;
            margin: 0;
            border: none;
            background-color: transparent;
            @include border-radius(4px);
            cursor: pointer;
            text-align: left;
            transition: background-color 0.2s ease-in-out;

            &:hover:not(.selected) {
                background-color: $color-neutral-200;
            }

            &.selected {
                background-color: $color-neutral-200;
            }
        }

        &__radio {
            flex: 0 0 auto;
            width: 18px;
            height: 18px;
            border: 2px solid $color-neutral-400;
            @include border-radius(100%);
            box-sizing: border-box;
            position: relative;

            &.is-checked {
                border-color: $color-primary-500;

                &::after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 10px;
                    height: 10px;
                    @include border-radius(100%);
                    background-color: $color-primary-500;
                    transform: translate(-50%, -50%);
                }
            }
        }

        &__option-label {
            @include font-size(sm);
            font-family: $text;
            color: $color-neutral-800;
            line-height: 1.3;
        }

        &__apply-btn {
            flex: 1 1 calc(50% - 4px);
            width: calc(50% - 4px);
            max-width: calc(50% - 4px);
            min-width: 0;
            height: 44px;
            margin: 0;
            padding: 0 12px;
            border: none;
            box-sizing: border-box;
            @include border-radius(4px);
            background-color: $color-primary-500;
            color: $color-white;
            font-family: $text-bold;
            font-size: 16px;
            line-height: 1;
            cursor: pointer;

            &:hover {
                filter: brightness(0.95);
            }
        }

        &__actions {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: stretch;
            gap: 8px;
            margin-top: auto;

            ::v-deep .content-button {
                flex: 1 1 calc(50% - 4px);
                width: calc(50% - 4px);
                max-width: calc(50% - 4px);
                min-width: 0;
                padding: 0 !important;
                box-sizing: border-box;
            }

            ::v-deep .btn.selector-popup,
            ::v-deep .btn-cancel.selector-popup {
                width: 100% !important;
                max-width: 100%;
                margin: 0 !important;
                height: 44px;
                box-sizing: border-box;
                color: var(--neutro-s90) !important;
            }

            ::v-deep .btn-cancel.selector-popup span {
                color: var(--neutro-s90) !important;
            }
        }

        &.portrait {
            min-height: 340px;
            gap: 20px;

            .change-view-modal__section-title {
                font-size: 14px;
            }

            .change-view-modal__option-label {
                font-size: 18px;
                line-height: 1.3;
            }

            .change-view-modal__apply-btn {
                font-size: 20px;
            }

            .change-view-modal__actions {
                ::v-deep .btn.selector-popup,
                ::v-deep .btn-cancel.selector-popup,
                ::v-deep .btn-cancel.selector-popup span {
                    font-size: 20px;
                    line-height: 1;
                }
            }
        }
    }
}
</style>

<style lang="scss">
.action-buttons .content-button .btn {
    padding: 0 !important;
}

/* BUILD-7551: proporciones del modal Cambiar vista (más alto, menos ancho) */
.popup-change-view {
    .custom-modal.popup-change-view__panel {
        width: 320px !important;
        max-width: calc(100vw - 48px) !important;
        min-height: 400px !important;
    }

    .change-view-modal.portrait {
        .change-view-modal__apply-btn,
        .change-view-modal__actions .btn.selector-popup,
        .change-view-modal__actions .btn-cancel.selector-popup,
        .change-view-modal__actions .btn-cancel.selector-popup span {
            font-size: 20px;
        }

        .change-view-modal__option-label {
            font-size: 18px;
        }
    }

    .change-view-modal__actions {
        .content-button,
        .change-view-modal__apply-btn {
            flex: 1 1 calc(50% - 4px);
            width: calc(50% - 4px);
            max-width: calc(50% - 4px);
            min-width: 0;
            padding-left: 0 !important;
            padding-right: 0 !important;
            box-sizing: border-box;
        }

        .btn-cancel.selector-popup {
            width: 100% !important;
            max-width: 100%;
            margin: 0 !important;
            box-sizing: border-box;
        }

        .btn-cancel.selector-popup,
        .btn-cancel.selector-popup span {
            color: var(--neutro-s90) !important;
        }
    }

    .custom-modal-header {
        padding: 20px 24px;
    }

    .custom-modal-content {
        flex: 1 1 auto;
        padding-top: 28px !important;
        padding-left: 24px;
        padding-right: 24px;
        padding-bottom: 28px !important;
        overflow-y: auto;
    }
}

#popup-to-print-timer {
    .custom-modal-content {
        padding-bottom: 0 !important;
    }
    .list {
        margin: 40px 0 24px !important;

        .title {
            color: var(--color-black, #222);
            font-family: 'Avenir-Bold';
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }

        .message {
            color: var(--color-black, #222);
            font-family: 'Avenir-Regular';
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
    }

    .action-buttons {
        display: inline-flex;
        width: 100%;

        .content-button {
            padding: 0 5px !important;
            display: inline-flex;
            align-items: center;
        }
    }
}
</style>
